var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
(function () {
    angular.module('QMC.Roster', []).config(routes);
    routes.$inject = ['$locationProvider', '$stateProvider', 'qmcBase'];
    function routes($locationProvider, $stateProvider, qmcBase) {
        $locationProvider.html5Mode({
            enabled: false,
            requireBase: false
        });
        $stateProvider
            .state('Roster', {
            url: '/roster?:startDay',
            templateUrl: qmcBase + '/roster',
            controller: 'RosterController',
            controllerAs: 'vm',
            resolve: {
                data: [function () {
                        console.log('Current State: Roster');
                    }]
            },
            params: {
                startDay: {
                    dynamic: true
                }
            }
        });
    }
})();
var QMC;
(function (QMC) {
    var Roster;
    (function (Roster) {
        var Constants = /** @class */ (function () {
            function Constants() {
            }
            Constants.SERVICE = "2db0eb84-7e2c-45c0-bde7-89d3fc7ba86b";
            Constants.SUBTYPE_PLANNED = "20f4990c-f722-4358-9a53-01e4c013a691";
            Constants.SUBTYPE_DOCUMENTED = "8762a244-16c8-412e-93b6-1e21f3c25222";
            Constants.MISCELLANIOUS_TEMPLATE = '5d70cf86-cb00-4524-8ebd-02d43c754abf';
            Constants.SERVICE_WV_HOLIDAY = '370c3177-db5b-4673-bc9f-b49bc9e242c7';
            Constants.SERVICE_TYPE_HOLIDAY = '8bdf6a27-a881-4b4b-8abf-3bedb5156df2';
            Constants.SERVICE_SUBTYPE_HOLIDAY_HOLIDAY = 'be395209-7121-48f7-af6c-cb66563a1841';
            Constants.SERVICE_SUBTYPE_HOLIDAY_SPECIAL = '105fcc3c-ed8f-405a-bc60-c32fd75bf14f';
            Constants.SERVICE_SUBTYPE_HOLIDAY_TRAINING = 'a7da1703-ef0d-4384-a868-c73e25683adb';
            Constants.SERVICE_WV_DISEASE = '122cef0e-ba67-4a69-aa5a-98aec16fb4f0';
            Constants.SERVICE_TYPE_DISEASE = 'dac03d14-8a88-4030-91db-ad65998986c2';
            Constants.SERVICE_SUBTYPE_DISEASE_STANDARD = '66783b01-9502-43db-a1af-9bbbcf48a1cf';
            Constants.SERVICE_SUBTYPE_DISEASE_ACCIDENT = '642bf8b1-f3a0-4755-9c66-b757f67f9d78';
            Constants.SERVICE_TYPE_EXEMPTION = '281aa8c1-340d-4ee3-979c-b8dc218a1a28';
            Constants.SERVICE_WV_EXEMPTION = 'e8feeb37-20cb-4a72-9b04-49f92fbd0dd4';
            Constants.SERVICE_SICKNOTETYPE_INITIALDOCUMENT = '37dd9194-a5b7-4055-a152-4aa0da30543b';
            return Constants;
        }());
        Roster.Constants = Constants;
    })(Roster = QMC.Roster || (QMC.Roster = {}));
})(QMC || (QMC = {}));
var QMC;
(function (QMC) {
    var Roster;
    (function (Roster) {
        var RosterService = /** @class */ (function (_super) {
            __extends(RosterService, _super);
            function RosterService($http, $q) {
                var _this = _super.call(this, $http, $q) || this;
                _this.$http = $http;
                _this.$q = $q;
                _this.modulePath = '/Roster';
                ////////////////////////// SERVICE PLANNING //////////////////////////
                _this.servicePlanningPath = "/Service";
                ////////////////////////// SICKLEAVE //////////////////////////
                _this.sickLeavePath = "/SickLeave";
                _this.sickNotePath = "/SickNote";
                ////////////////////////// Exemption //////////////////////////
                _this.exemptionPath = "/Exemption";
                return _this;
            }
            RosterService.prototype.getTemplates = function () {
                return _super.prototype.get.call(this, this.modulePath + "/Template", {}, function (data) {
                    return data;
                });
            };
            RosterService.prototype.getRosterWv = function () {
                return _super.prototype.getItem.call(this, this.modulePath + '/WvModel', {}, function (data) {
                    return data;
                });
            };
            RosterService.prototype.getReferences = function (objectType) {
                return _super.prototype.get.call(this, this.modulePath + '/Reference', { objectType: objectType }, function (data) {
                    return data;
                });
            };
            RosterService.prototype.getRosterData = function (referenceIds, referenceType, dateFrom, dateTo, predefinedView, includeSub, loadWorkingEventsData) {
                if (includeSub === void 0) { includeSub = false; }
                if (loadWorkingEventsData === void 0) { loadWorkingEventsData = true; }
                return _super.prototype.getItem.call(this, this.modulePath, { referenceIds: referenceIds, referenceObjectType: referenceType, dateFrom: dateFrom, dateTo: dateTo, predefinedViewId: predefinedView, includeSub: includeSub, loadWorkingEventsData: loadWorkingEventsData }, function (data) {
                    return data;
                });
            };
            RosterService.prototype.getAwayData = function (dateFrom, dateTo) {
                return _super.prototype.get.call(this, this.modulePath + '/Away', { dateFrom: dateFrom, dateTo: dateTo }, function (data) {
                    return data;
                });
            };
            RosterService.prototype.postServicePlanning = function (data) {
                return _super.prototype.post.call(this, this.modulePath + this.servicePlanningPath, data).then(function (d) {
                    return d;
                });
            };
            RosterService.prototype.postServiceDocu = function (id, data) {
                return _super.prototype.post.call(this, this.modulePath + this.servicePlanningPath + "/" + id, data).then(function (d) {
                    return d;
                });
            };
            RosterService.prototype.putService = function (id, data) {
                return _super.prototype.put.call(this, this.modulePath + this.servicePlanningPath + "/" + id, data).then(function (data) {
                    return data;
                });
            };
            RosterService.prototype.getService = function (id) {
                return _super.prototype.getItem.call(this, this.modulePath + this.servicePlanningPath + "/" + id, {}, function (d) {
                    return d;
                });
            };
            RosterService.prototype.deleteService = function (id) {
                return _super.prototype.delete.call(this, this.modulePath + this.servicePlanningPath + '/' + id).then(function (data) {
                    return data;
                });
            };
            RosterService.prototype.checkForConflictErrors = function (data) {
                return _super.prototype.post.call(this, this.modulePath + this.servicePlanningPath + '/Validation/', data).then(function (data) {
                    return data;
                });
            };
            RosterService.prototype.validateNonService = function (data) {
                return _super.prototype.post.call(this, this.modulePath + this.servicePlanningPath + '/Validation/NewNonService', data).then(function (data) {
                    return data;
                });
            };
            RosterService.prototype.calculateDayValues = function (dateFrom, dateTo, referenceId) {
                return _super.prototype.post.call(this, this.modulePath + this.servicePlanningPath + "/CalculateDayValues", { dateFrom: dateFrom, dateTo: dateTo, referenceId: referenceId }).then(function (data) {
                    return data;
                });
            };
            RosterService.prototype.postSickLeave = function (data) {
                return _super.prototype.post.call(this, this.modulePath + this.sickLeavePath, data).then(function (d) {
                    return d;
                });
            };
            RosterService.prototype.putSickLeave = function (id, data) {
                return _super.prototype.put.call(this, this.modulePath + this.sickLeavePath + "/" + id, data).then(function (data) {
                    return data;
                });
            };
            RosterService.prototype.getSickLeave = function (id) {
                return _super.prototype.getItem.call(this, this.modulePath + this.sickLeavePath + "/" + id, {}, function (d) {
                    return d;
                });
            };
            RosterService.prototype.deleteSickLeave = function (id) {
                return _super.prototype.delete.call(this, this.modulePath + this.sickLeavePath + '/' + id).then(function (data) {
                    return data;
                });
            };
            RosterService.prototype.getSickLeaveWv = function () {
                return _super.prototype.getItem.call(this, this.modulePath + this.sickLeavePath + '/WvModel', {}, function (data) {
                    return data;
                });
            };
            RosterService.prototype.postSickNote = function (sickLeaveId, data) {
                return _super.prototype.post.call(this, "" + this.modulePath + this.sickLeavePath + "/" + sickLeaveId + this.sickNotePath, data).then(function (d) {
                    return d;
                });
            };
            RosterService.prototype.putSickNote = function (sickLeaveId, sickNoteId, data) {
                return _super.prototype.put.call(this, "" + this.modulePath + this.sickLeavePath + "/" + sickLeaveId + this.sickNotePath + "/" + sickNoteId, data).then(function (data) {
                    return data;
                });
            };
            RosterService.prototype.getSickNote = function (sickLeaveId, sickNoteId) {
                return _super.prototype.getItem.call(this, "" + this.modulePath + this.sickLeavePath + "/" + sickLeaveId + this.sickNotePath + "/" + sickNoteId, {}, function (d) {
                    return d;
                });
            };
            RosterService.prototype.getSickNoteList = function (sickLeaveId) {
                return _super.prototype.getItem.call(this, "" + this.modulePath + this.sickLeavePath + "/" + sickLeaveId + this.sickNotePath, {}, function (d) {
                    return d;
                });
            };
            RosterService.prototype.deleteSickNote = function (sickLeaveId, sickNoteId) {
                return _super.prototype.delete.call(this, "" + this.modulePath + this.sickLeavePath + "/" + sickLeaveId + this.sickNotePath + "/" + sickNoteId).then(function (data) {
                    return data;
                });
            };
            RosterService.prototype.postExemption = function (data) {
                return _super.prototype.post.call(this, this.modulePath + this.exemptionPath, data).then(function (d) {
                    return d;
                });
            };
            RosterService.prototype.putExemption = function (id, data) {
                return _super.prototype.put.call(this, this.modulePath + this.exemptionPath + "/" + id, data).then(function (data) {
                    return data;
                });
            };
            RosterService.prototype.getExemption = function (id) {
                return _super.prototype.getItem.call(this, this.modulePath + this.exemptionPath + "/" + id, {}, function (d) {
                    return d;
                });
            };
            RosterService.prototype.deleteExemption = function (id) {
                return _super.prototype.delete.call(this, this.modulePath + this.exemptionPath + '/' + id).then(function (data) {
                    return data;
                });
            };
            RosterService.prototype.getExemptionWv = function () {
                return _super.prototype.getItem.call(this, this.modulePath + this.exemptionPath + '/WvModel', {}, function (data) {
                    return data;
                });
            };
            RosterService = __decorate([
                QMC.Service('QMC.Roster', 'RosterService'),
                QMC.Inject('$http', '$q')
            ], RosterService);
            return RosterService;
        }(QMC.Common.BaseService));
        Roster.RosterService = RosterService;
    })(Roster = QMC.Roster || (QMC.Roster = {}));
})(QMC || (QMC = {}));
var QMC;
(function (QMC) {
    var Roster;
    (function (Roster) {
        var RosterController = /** @class */ (function () {
            /////////////////////////// CONSTRUCTOR //////////////////////////
            function RosterController($location, rosterService, $qui, $scope, $stateParams, $state, lng, permissionService, clientService, userService, $compile, $timeout) {
                var _this_1 = this;
                this.$location = $location;
                this.rosterService = rosterService;
                this.$qui = $qui;
                this.$scope = $scope;
                this.$stateParams = $stateParams;
                this.$state = $state;
                this.lng = lng;
                this.permissionService = permissionService;
                this.clientService = clientService;
                this.userService = userService;
                this.$compile = $compile;
                this.$timeout = $timeout;
                //////////////////////////// VARIABLES ///////////////////////////
                this.supportMiscTemplates = [Roster.Constants.SERVICE_TYPE_HOLIDAY, Roster.Constants.SERVICE_TYPE_EXEMPTION, Roster.Constants.SERVICE_TYPE_DISEASE];
                this.localStorageItemName = "RosterSettings";
                this.isMobile = false;
                this.scrollPosition = 0;
                this.debounceCheckShowWeekends = false;
                this.debounceCheckHighlightWeekends = false;
                this.debounceCheckShowWorkingEventsInfo = false;
                this.debounceCheck = false;
                this.calendarCreated = false;
                this.showValidationBox = false;
                this.calendarNoReload = false; //when removing a reference, no need to call the api for new data, just delete the reference from the calendar resources
                this.askDroppedService = QMC.Common.UserSettingConstantsAndDefaults.ASKDROPPEDSERVICE;
                this.institutes = [];
                this.employees = [];
                this.serviceAdditionals = [];
                this.referenceTypes = [];
                this.references = [];
                this.predefinedViews = [];
                this.employeesList = [];
                this.rosterResources = [];
                this.rosterData = [];
                this.rosterEvents = [];
                this.isNegativeTimePeriodLock = false;
                this.resourceViewMobileCreated = false;
                this.loading = {
                    template: false, calendar: false, institute: false, employee: true, wv: false, referenceTypes: false, references: false, detail: false, permission: false,
                    allLoaded: function () {
                        return !(_this_1.loading.template || _this_1.loading.institute || _this_1.loading.employee || _this_1.loading.wv || _this_1.loading.referenceTypes
                            || _this_1.loading.references || _this_1.loading.detail || _this_1.loading.permission);
                    },
                };
                this.permission = {
                    view: false,
                    service: {
                        new: false,
                        modify: false,
                        delete: false
                    },
                    serviceDocumenteted: {
                        new: false,
                        modify: false,
                        delete: false,
                        openFile: false
                    }
                };
                this.servicePermission = {
                    view: false,
                    new: false,
                    modify: false,
                    delete: false
                };
                this.rosterSettings = {
                    showWeekends: true,
                    showWorkingEventsInfo: true,
                    viewDate: new Date(),
                    dataFrom: new Date(),
                    dataTo: new Date(),
                    references: [],
                    predefinedView: QMC.Common.Constants.GUID_EMPTY,
                    referenceType: 120000,
                    defaultSchedulerView: 'timelineMonth',
                    highlightWeekends: true,
                    includeSub: false,
                    showOnlyActiveReferences: true
                };
                this.dblClick = null;
                this.clickTimer = null;
                this.isDragging = false;
                this.formState = 'new';
                ///////// Holiday
                this.holidayPermissions = { standard: undefined, special: undefined, approved: undefined, document: undefined, documentSpecial: undefined };
                this.holidayCallbacks = { onNew: function () { return _this_1.getRosterData(true); }, onEdit: function () { return _this_1.getRosterData(true); }, onDelete: function () { return _this_1.getRosterData(true); } };
                this.exemptionCallbacks = { onNew: function () { return _this_1.getRosterData(true); }, onEdit: function () { return _this_1.getRosterData(true); }, onDelete: function () { return _this_1.getRosterData(true); } };
                ///////// SickLeave
                this.sickLeavePermissions = { standard: undefined, accident: undefined, document: undefined };
                this.sickLeaveCallbacks = { onNew: function () { return _this_1.getRosterData(true); }, onEdit: function () { return _this_1.getRosterData(true); }, onDelete: function () { return _this_1.getRosterData(true); } };
                this.keepData = false;
                $qui.init($qui.getSectionColor($location.path()), function () {
                    $qui.anonAvatar();
                    $qui.bindEvents();
                    $qui.navToggle();
                });
                this.selectedReferences = [];
                var localStorageItem = localStorage.getItem(this.localStorageItemName);
                if (localStorageItem !== null && localStorageItem !== "") {
                    console.log(JSON.parse(localStorageItem).dataFrom);
                    this.rosterSettings = JSON.parse(localStorageItem);
                    this.rosterSettings.dataFrom = new Date();
                    this.rosterSettings.dataTo = new Date();
                    this.selectedReferences = this.rosterSettings.referenceType === 120000 ? this.rosterSettings.references : [];
                    this.selectedReference = this.rosterSettings.referenceType !== 120000 ? this.rosterSettings.references[0] : QMC.Common.Constants.GUID_EMPTY;
                }
                else
                    this.rosterSettings.references = [$('#session').data().personId];
                if (this.$stateParams.startDay) {
                    this.rosterSettings.dataFrom = moment(this.$stateParams.startDay).toDate();
                    this.rosterSettings.dataTo = moment(this.$stateParams.startDay).toDate();
                }
                else {
                    this.$stateParams.startDay = new Date();
                }
                this.validation = {
                    errors: [],
                    warnings: [],
                    isLoading: false
                };
                if (QMC.Common.Constants.IS_MOBILE) {
                    this.isMobile = true;
                    this.rosterSettings.showWorkingEventsInfo = true;
                }
                var _this = this;
                this.events();
                this.init();
                // get Permissions
                this.loading.permission = true;
                permissionService.getPermissionsByObjectTypes([410000, 411001, 120031, 120030, 411003, 411005, 120024, 411004, 411006, 411008, 411007, 411015, 411016, 411017]).then(function (data) {
                    _this_1.permission.view = data[0].view && data[0].moduleAccess;
                    _this_1.loading.permission = false;
                    if (!_this_1.permission.view)
                        return;
                    _this_1.servicePermission = $.grep(data, function (e) { return e.objectType === 411001; })[0];
                    //chek if the user has permission for documentating events / istzeit erfassen
                    _this_1.permission.serviceDocumenteted.openFile = data[2].openFile;
                    _this_1.permission.service = {
                        new: _this_1.servicePermission.new,
                        modify: _this_1.servicePermission.modify,
                        delete: _this_1.servicePermission.delete
                    };
                    _this_1.wtOverviewPermission = $.grep(data, function (e) { return e.objectType === 120030; })[0];
                    _this_1.holidayPermissions.standard = $.grep(data, function (e) { return e.objectType === 411003; })[0];
                    _this_1.holidayPermissions.special = $.grep(data, function (e) { return e.objectType === 411005; })[0];
                    _this_1.holidayPermissions.approved = $.grep(data, function (e) { return e.objectType === 120024; })[0];
                    _this_1.holidayPermissions.document = $.grep(data, function (e) { return e.objectType === 411016; })[0];
                    _this_1.holidayPermissions.documentSpecial = $.grep(data, function (e) { return e.objectType === 411017; })[0];
                    _this_1.sickLeavePermissions.standard = $.grep(data, function (e) { return e.objectType === 411003; })[0];
                    _this_1.sickLeavePermissions.accident = $.grep(data, function (e) { return e.objectType === 411006; })[0];
                    _this_1.sickLeavePermissions.document = $.grep(data, function (e) { return e.objectType === 411008; })[0];
                    _this_1.exemptionPermissions = {
                        standard: $.grep(data, function (e) { return e.objectType === 411007; })[0],
                        approved: $.grep(data, function (e) { return e.objectType === 120024; })[0],
                        document: $.grep(data, function (e) { return e.objectType === 411015; })[0]
                    };
                    // load settings
                    _this_1.userService.getUserSettings(['ROSTER.ASKDROPPEDSERVICE']).then(function (data) {
                        _this_1.askDroppedService = data[0].value === '' ? QMC.Common.UserSettingConstantsAndDefaults.ASKDROPPEDSERVICE : data[0].value.toLowerCase() === 'true';
                    });
                    //setup the calendar
                    _this_1.setupCalendar();
                    // load data
                    _this_1.getTemplates();
                    _this_1.getInstitutes();
                    _this_1.getEmployees();
                    _this_1.getWvList();
                });
                this.resetCalendar();
            }
            ////////////////////////// DISPLAYLOGIC //////////////////////////
            ///// BEGIN Handler for selectNewServiceModal /////
            RosterController.prototype.openNewServiceSelect = function () {
                var _this_1 = this;
                var _a;
                if (!this.loading.allLoaded())
                    return;
                this.selectedNewReference = $('#session').data().personId;
                if (!this.employees.some(function (x) { return x.value === _this_1.selectedNewReference; }))
                    this.selectedNewReference = (_a = this.employees[0]) === null || _a === void 0 ? void 0 : _a.value;
                $('#selectNewServiceModal').modal('show');
            };
            // Button click handler for a template item
            RosterController.prototype.newServiceSelected = function (template) {
                var _this_1 = this;
                var reference = this.employees.filter(function (x) { return x.value === _this_1.selectedNewReference; })[0];
                this.eventReference = {
                    id: reference.value,
                    instituteId: reference.instituteId,
                    name: reference.text
                };
                var wantedRosterType = { rosterTypeId: Roster.Constants.SERVICE, rosterSubTypeId: Roster.Constants.SUBTYPE_PLANNED };
                this.handleTemplateDrop(template, moment().startOf('day').toDate(), wantedRosterType);
            };
            // Button click handler if general "Soll-Dienst" was clicked
            RosterController.prototype.newServiceSelectedGeneralPlanning = function () {
                var _this_1 = this;
                var reference = this.employees.filter(function (x) { return x.value === _this_1.selectedNewReference; })[0];
                this.initNewForm();
                $('#new-service-modal').modal('show');
                this.serviceForm.referenceIds = [reference.value];
            };
            ///// END Handler for selectNewServiceModal /////
            // Handle drop of a template on a cell
            RosterController.prototype.handleTemplateDrop = function (template, date, droppedOnRosterType) {
                if (template.instituteId !== Roster.Constants.MISCELLANIOUS_TEMPLATE) {
                    this.handleRosterDrop(template, date, droppedOnRosterType);
                }
                else if (template.serviceTypeId == Roster.Constants.SERVICE_TYPE_HOLIDAY) {
                    this.handleHolidayDrop(template, date);
                }
                else if (template.serviceTypeId == Roster.Constants.SERVICE_TYPE_DISEASE) {
                    this.handleDiseaseDrop(template, date);
                }
                else if (template.serviceTypeId == Roster.Constants.SERVICE_TYPE_EXEMPTION) {
                    this.handleExemptionDrop(template, date);
                }
                else {
                    this.$qui.notify({
                        title: "Sorry",
                        message: "Not yet implemented",
                        icon: 'qm-icon-error',
                        status: 'default',
                        timer: 3000,
                        delay: 1500
                    });
                }
                this.$qui.scopeApply(this.$scope);
            };
            // Handle a roster template drop
            RosterController.prototype.handleRosterDrop = function (template, date, droppedOnRosterType) {
                var _a, _b;
                var wantedRosterType = (_a = droppedOnRosterType === null || droppedOnRosterType === void 0 ? void 0 : droppedOnRosterType.rosterTypeId) !== null && _a !== void 0 ? _a : Roster.Constants.SERVICE;
                var wantedSubType = (_b = droppedOnRosterType === null || droppedOnRosterType === void 0 ? void 0 : droppedOnRosterType.rosterSubTypeId) !== null && _b !== void 0 ? _b : Roster.Constants.SUBTYPE_PLANNED;
                var wantToCreateIsTime = wantedRosterType === Roster.Constants.SERVICE && wantedSubType === Roster.Constants.SUBTYPE_DOCUMENTED;
                var dateTo = this.calculateDateTo(date, template);
                this.validation.errors = [];
                this.validation.isLoading = false;
                var calendarInfo = {
                    date: date,
                    timeFrom: null,
                    timeTo: null,
                    referenceRessource: this.eventReference.id,
                    referenceInstituteId: template.instituteId
                };
                this.initNewForm(template, calendarInfo);
                this.serviceForm.dateFrom = date;
                this.serviceForm.dateTo = dateTo;
                // This will create an Is-Time
                if (wantToCreateIsTime) {
                    this.serviceForm.parentId = QMC.Common.Constants.GUID_EMPTY;
                }
                var mustOpenModal = this.askDroppedService || ((!wantToCreateIsTime) && this.isDateLockedForType(this.serviceForm.referenceIds, Roster.Constants.SUBTYPE_PLANNED, this.serviceForm.dateFrom, dateTo));
                if (mustOpenModal)
                    this.openNewServiceModal();
                else
                    this.saveNewService(this.serviceForm, false, wantToCreateIsTime);
            };
            RosterController.prototype.handleHolidayDrop = function (template, date) {
                var _a, _b;
                if (template.serviceSubTypeId === Roster.Constants.SERVICE_SUBTYPE_HOLIDAY_HOLIDAY && this.holidayPermissions.standard.new || template.serviceSubTypeId === Roster.Constants.SERVICE_SUBTYPE_HOLIDAY_SPECIAL && this.holidayPermissions.special.new) {
                    this.holidayCalls.new({
                        comment: "",
                        dateFrom: moment(date).startOf('day').toDate(),
                        dateTo: moment(date).endOf('day').toDate(),
                        holidayTypeId: null,
                        isSpecialHoliday: template.serviceSubTypeId === Roster.Constants.SERVICE_SUBTYPE_HOLIDAY_SPECIAL,
                        color: template.color,
                        amountOfDays: 1,
                        amountOfHours: 0,
                        accountingTypeFlag: 0,
                        isManualDays: true,
                        isManualHours: false,
                        creditWorkAsHoliday: false,
                        permissionApproved: (_a = this.holidayPermissions.approved) === null || _a === void 0 ? void 0 : _a.openFile,
                        approvedId: ((_b = this.holidayPermissions.approved) === null || _b === void 0 ? void 0 : _b.openFile) ? QMC.Common.Constants.APPROVAL_APRROVED_ID : QMC.Common.Constants.APPROVAL_PENDING_ID
                    });
                }
                else {
                    this.$qui.notify({
                        title: template.caption,
                        message: this.lng.translate(20025005, 'Ihnen fehlt die Berechtigung'),
                        icon: 'qm-icon-error',
                        status: 'default',
                        timer: 3000,
                        delay: 1500
                    });
                }
            };
            RosterController.prototype.handleDiseaseDrop = function (template, date) {
                var _a, _b, _c, _e;
                if (template.serviceSubTypeId === Roster.Constants.SERVICE_SUBTYPE_DISEASE_STANDARD && this.sickLeavePermissions.standard.new || template.serviceSubTypeId === Roster.Constants.SERVICE_SUBTYPE_DISEASE_ACCIDENT && this.sickLeavePermissions.accident.new) {
                    this.sickLeaveCalls.new({
                        id: null,
                        objectId: null,
                        comment: '',
                        dateFrom: moment(date).startOf('day').toDate(),
                        dateTo: moment(date).endOf('day').toDate(),
                        color: template.color,
                        amountOfDays: 0,
                        amountOfHours: 0,
                        accountingTypeFlag: 0,
                        caption: template.serviceSubTypeId === Roster.Constants.SERVICE_SUBTYPE_DISEASE_ACCIDENT ? this.lng.translate(0, 'Arbeitsunfall') : this.lng.translate(0, 'Krankheit'),
                        captionShort: (template.serviceSubTypeId === Roster.Constants.SERVICE_SUBTYPE_DISEASE_ACCIDENT ? this.lng.translate(0, 'Arbeitsunfall') : this.lng.translate(0, 'Krankheit')).substring(0, 1).toUpperCase(),
                        diseaseKindId: null,
                        referenceId: (_b = (_a = this.eventReference) === null || _a === void 0 ? void 0 : _a.id) !== null && _b !== void 0 ? _b : $('#session').data().personId,
                        instituteId: (_e = (_c = this.eventReference) === null || _c === void 0 ? void 0 : _c.instituteId) !== null && _e !== void 0 ? _e : null,
                        serviceSubTypeId: template.serviceSubTypeId
                    });
                }
                else {
                    this.$qui.notify({
                        title: template.caption,
                        message: this.lng.translate(20025005, 'Ihnen fehlt die Berechtigung'),
                        icon: 'qm-icon-error',
                        status: 'default',
                        timer: 3000,
                        delay: 1500
                    });
                }
            };
            RosterController.prototype.handleExemptionDrop = function (template, date) {
                var _a, _b, _c, _e, _f;
                if (this.exemptionPermissions.standard.new) {
                    this.exemptionCalls.new({
                        comment: '',
                        dateFrom: moment(date).startOf('day').toDate(),
                        dateTo: moment(date).endOf('day').toDate(),
                        color: template.color,
                        caption: this.lng.translate(20028042, 'Freistellung'),
                        captionShort: this.lng.translate(20028042, 'Freistellung').substring(0, 1).toUpperCase(),
                        exemptionKindId: null,
                        referenceId: (_b = (_a = this.eventReference) === null || _a === void 0 ? void 0 : _a.id) !== null && _b !== void 0 ? _b : $('#session').data().personId,
                        instituteId: (_e = (_c = this.eventReference) === null || _c === void 0 ? void 0 : _c.instituteId) !== null && _e !== void 0 ? _e : null,
                        serviceSubTypeId: template.serviceSubTypeId,
                        permissionApproved: (_f = this.exemptionPermissions.approved) === null || _f === void 0 ? void 0 : _f.openFile,
                        approvedId: QMC.Common.Constants.APPROVAL_PENDING_ID
                    });
                }
                else {
                    this.$qui.notify({
                        title: template.caption,
                        message: this.lng.translate(20025005, 'Ihnen fehlt die Berechtigung'),
                        icon: 'qm-icon-error',
                        status: 'default',
                        timer: 3000,
                        delay: 1500
                    });
                }
            };
            RosterController.prototype.calculateDateTo = function (date, template) {
                //kill time component of drop date and create new moment
                var dropDate = new Date(date.getFullYear(), date.getMonth(), date.getDate());
                var dropDateMoment = moment(dropDate);
                //get time component parts from dateFrom
                var momentTimeFrom = moment(template.timeFrom);
                var minutes = momentTimeFrom.minutes();
                var hours = momentTimeFrom.hours();
                //add hours and minutes to drop date
                var modDropDateMomentHours = dropDateMoment.clone().add(hours, 'hour');
                var modDropDateMomentMinutes = modDropDateMomentHours.clone().add(minutes, 'minute');
                //calculate timespan between the two dates in template
                var momentFrom = moment(template.timeFrom);
                var momentTo = moment(template.timeTo);
                var timespan = moment.duration(momentTo.diff(momentFrom));
                //add timespan to drop date and return dateTo
                return moment(modDropDateMomentMinutes).add(timespan).toDate();
            };
            RosterController.prototype.openExistingService = function (id) {
                this.formState = 'edit';
                $('#show-planning-modal').modal('hide');
                this.openNewServiceModal();
                this.getService(id);
            };
            RosterController.prototype.openExistingPlannedService = function (id) {
                $('#new-service-modal').modal('hide');
                $('#show-planning-modal').modal('show');
                this.getService(id);
            };
            RosterController.prototype.openModifyModal = function () {
                $('#show-planning-modal').modal('hide');
                this.openNewServiceModal();
                this.formState = 'edit';
            };
            RosterController.prototype.getTempaltesById = function (id) {
                if (this.templateList && this.templateList.filter(function (item) { return item.value === id; }).length > 0)
                    return this.templateList.filter(function (item) { return item.value === id; })[0].items;
                return null;
            };
            RosterController.prototype.resetCalendar = function (keepData) {
                var _this_1 = this;
                if (keepData === void 0) { keepData = false; }
                if (keepData)
                    this.keepData = true;
                $('#rosterCalendar').fullCalendar('destroy');
                this.setupCalendar(undefined);
                setTimeout(function () { return _this_1.keepData = false; }, 25);
            };
            RosterController.prototype.prepareForValidation = function (serviceForm, validationFormList, proposedConflictCheckAction) {
                if (proposedConflictCheckAction === void 0) { proposedConflictCheckAction = 0; }
                var _loop_1 = function (referenceItem) {
                    var formToValidate = angular.copy(serviceForm);
                    formToValidate.dateFrom = this_1.$qui.addTimeToDate(serviceForm.dateFrom, serviceForm.timeFrom);
                    formToValidate.dateTo = this_1.$qui.addTimeToDate(serviceForm.dateTo, serviceForm.timeTo);
                    formToValidate.reference = this_1.employeesList.filter(function (x) { return x.id === referenceItem; })[0].displayTitle;
                    formToValidate.referenceId = referenceItem;
                    formToValidate.institute = (serviceForm.instituteId !== null && serviceForm.instituteId !== undefined && serviceForm.instituteId !== QMC.Common.Constants.GUID_EMPTY) ? this_1.institutes.filter(function (x) { return x.value === serviceForm.instituteId; })[0].text : QMC.Common.Constants.GUID_EMPTY;
                    formToValidate.conflictProposedAction = proposedConflictCheckAction;
                    validationFormList.push(formToValidate);
                };
                var this_1 = this;
                for (var _i = 0, _a = serviceForm.referenceIds; _i < _a.length; _i++) {
                    var referenceItem = _a[_i];
                    _loop_1(referenceItem);
                }
            };
            RosterController.prototype.validate = function (form) {
                var _this_1 = this;
                if (form === void 0) { form = null; }
                if (!this.validationChanged())
                    return;
                this.validation.errors = [];
                this.validation.warnings = [];
                var listToCheck = [];
                this.prepareForValidation(form !== null && form !== void 0 ? form : this.serviceForm, listToCheck);
                this.lastValidation = JSON.stringify(listToCheck);
                this.validation.isLoading = true;
                this.rosterService.checkForConflictErrors(listToCheck).then(function (conflictsResult) {
                    _this_1.validation.errors = conflictsResult.errors;
                    _this_1.validation.warnings = conflictsResult.warnings;
                    _this_1.validation.isLoading = false;
                    _this_1.showValidationBox = true;
                });
            };
            RosterController.prototype.validationChanged = function (form) {
                if (form === void 0) { form = null; }
                if (!this.lastValidation)
                    return true;
                var listToCheck = [];
                this.prepareForValidation(form !== null && form !== void 0 ? form : this.serviceForm, listToCheck);
                listToCheck.forEach(function (x) { return delete x.conflictProposedAction; });
                var oldV = JSON.parse(this.lastValidation);
                oldV.forEach(function (x) { return delete x.conflictProposedAction; });
                return JSON.stringify(listToCheck) !== JSON.stringify(oldV);
            };
            RosterController.prototype.saveNewService = function (form, ignoreWarnings, postAsIsTime) {
                var _this_1 = this;
                if (ignoreWarnings === void 0) { ignoreWarnings = false; }
                if (postAsIsTime === void 0) { postAsIsTime = false; }
                this.validation.errors = [];
                this.validation.warnings = [];
                var listToCheck = [];
                this.prepareForValidation(form, listToCheck);
                this.lastValidation = JSON.stringify(listToCheck);
                //before saving check for conflicts
                form.dateFrom = this.$qui.addTimeToDate(form.dateFrom, form.timeFrom);
                form.dateTo = this.$qui.addTimeToDate(form.dateTo, form.timeTo);
                this.validation.isLoading = true;
                this.rosterService.checkForConflictErrors(listToCheck).then(function (conflictsResult) {
                    if (conflictsResult.errors.length > 0 || (conflictsResult.warnings.length > 0 && !ignoreWarnings)) {
                        _this_1.validation.errors = conflictsResult.errors;
                        _this_1.validation.warnings = conflictsResult.warnings;
                        _this_1.showValidationBox = true;
                    }
                    else {
                        if (!postAsIsTime)
                            _this_1.postPlanningOrIsTime(form);
                        else
                            _this_1.postIsTime(form);
                        $('#new-service-modal').modal('hide');
                    }
                }).finally(function () {
                    _this_1.validation.isLoading = false;
                });
            };
            RosterController.prototype.getAdditionalString = function (ids) {
                var result = "";
                var _loop_2 = function (i) {
                    result += $.grep(this_2.serviceAdditionals, function (e) { return e.value === ids[i]; })[0].text;
                    if (i < ids.length - 1)
                        result += ", ";
                };
                var this_2 = this;
                for (var i = 0; i < ids.length; i++) {
                    _loop_2(i);
                }
                return result;
            };
            RosterController.prototype.createNewServiceFromPlanning = function () {
                this.serviceForm.parentId = this.serviceForm.objectId;
                this.isLocked = this.isDateLockedForType(this.serviceForm.referenceIds, !this.serviceForm.parentId ? Roster.Constants.SUBTYPE_PLANNED : Roster.Constants.SUBTYPE_DOCUMENTED, this.serviceForm.dateFrom, this.serviceForm.dateTo);
                this.validation.errors = this.isLocked ? [this.lng.translate(20028012, 'Im ausgewählten Zeitraum existiert für mindestens einen ausgewählten Mitarbeiter eine Anlagesperre.')] : [];
                this.serviceForm.id = null;
                this.serviceForm.objectId = null;
                this.formState = 'new';
                $('#show-planning-modal').modal('hide');
                this.openNewServiceModal();
            };
            RosterController.prototype.openNewServiceModal = function () {
                $('#new-service-modal').modal('show');
            };
            RosterController.prototype.getTextColor = function (color) {
                var r = parseInt('0x' + color.substr(1, 2));
                var g = parseInt('0x' + color.substr(3, 2));
                var b = parseInt('0x' + color.substr(5, 2));
                var hsp = (r * 299 + g * 587 + b * 114) / 1000;
                // Using the HSP value, determine whether the color is light or dark
                if (hsp > 123) {
                    //light color, return black
                    return '#000000';
                }
                else {
                    //dark color return white
                    return '#FFFFFF';
                }
            };
            RosterController.prototype.isDateLockedForType = function (referenceIds, type, dateFrom, dateTo) {
                if (!referenceIds || !this.locks)
                    return false;
                var _loop_3 = function (referenceId) {
                    var referenceLocks = this_3.locks.filter(function (item) { return item.id === referenceId; });
                    if (referenceLocks.length === 0)
                        return { value: false };
                    var actualLocks = referenceLocks[0].locks.filter(function (item) { return item.subTypeId === type; });
                    for (var _i = 0, actualLocks_1 = actualLocks; _i < actualLocks_1.length; _i++) {
                        var actualLock = actualLocks_1[_i];
                        var lockRange = moment.range(moment(actualLock.dateFrom).startOf('day'), moment(actualLock.dateTo).endOf('day'));
                        var eventRange = moment.range(dateFrom, moment(dateTo).endOf('day'));
                        if (lockRange.overlaps(eventRange))
                            return { value: true };
                    }
                };
                var this_3 = this;
                for (var _i = 0, referenceIds_1 = referenceIds; _i < referenceIds_1.length; _i++) {
                    var referenceId = referenceIds_1[_i];
                    var state_1 = _loop_3(referenceId);
                    if (typeof state_1 === "object")
                        return state_1.value;
                }
                return false;
            };
            RosterController.prototype.showLocks = function (id) {
                this.selectedPerson = this.rosterData.filter(function (item) { return item.id === id; })[0] ? { name: this.rosterData.filter(function (item) { return item.id === id; })[0].caption, locks: this.rosterData.filter(function (item) { return item.id === id; })[0].locks } : { name: '', locks: [] };
                for (var _i = 0, _a = this.selectedPerson.locks; _i < _a.length; _i++) {
                    var lock = _a[_i];
                    lock.lockedTypeNames = [];
                    if (lock.subTypeId === Roster.Constants.SUBTYPE_PLANNED)
                        lock.lockedTypeNames.push(this.lng.translate(20028004, 'Soll-Dienst'));
                    if (lock.subTypeId === Roster.Constants.SUBTYPE_DOCUMENTED)
                        lock.lockedTypeNames.push(this.lng.translate(20028003, 'Ist-Dienst'));
                }
                $('#show-lock-modal').modal('show');
            };
            RosterController.prototype.showTemplates = function () {
                $('#templateDiv').show();
            };
            RosterController.prototype.hideTemplates = function () {
                if (!this.isDragging) {
                    $('#templateDiv').hide();
                    this.$compile(angular.element($('.lockBtn')).contents())(this.$scope);
                }
            };
            RosterController.prototype.showSettings = function () {
                $('#settingDiv').show();
            };
            RosterController.prototype.hideSettings = function () {
                $('#settingDiv').hide();
            };
            RosterController.prototype.showInfos = function () {
                this.setupCalendar(true);
                $('#rosterCalendarRessourcesDialog').modal('show');
            };
            ////////////////////////// SERVICECALLS //////////////////////////
            RosterController.prototype.getTemplates = function () {
                var _this_1 = this;
                this.loading.template = true;
                this.rosterService.getTemplates().then(function (data) {
                    _this_1.templateList = [];
                    //remove not supported misc. templates
                    data = data.filter(function (x) { return x.instituteId !== Roster.Constants.MISCELLANIOUS_TEMPLATE || _this_1.supportMiscTemplates.some(function (y) { return y === x.serviceTypeId; }); });
                    var _loop_4 = function (element) {
                        var template = element;
                        if (!_this_1.permission.service.new && template.instituteId !== Roster.Constants.MISCELLANIOUS_TEMPLATE)
                            return "continue";
                        var instituteContainer = _this_1.templateList.filter(function (item) { return item.value === template.instituteId; })[0];
                        if (instituteContainer)
                            instituteContainer.items.push(template);
                        else
                            _this_1.templateList.push({
                                text: template.institute,
                                value: template.instituteId,
                                items: [template]
                            });
                    };
                    // sort list elements by their institute
                    for (var _i = 0, data_1 = data; _i < data_1.length; _i++) {
                        var element = data_1[_i];
                        _loop_4(element);
                    }
                    if (_this_1.templateList.length > 0)
                        _this_1.selectedTemplateContainer = _this_1.templateList[0].value;
                    if (_this_1.templateList.filter(function (x) { return x.value === Roster.Constants.MISCELLANIOUS_TEMPLATE; }))
                        _this_1.selectedTemplateContainer = Roster.Constants.MISCELLANIOUS_TEMPLATE;
                    _this_1.loading.template = false;
                    _this_1.setupDndEvents();
                });
            };
            RosterController.prototype.getInstitutes = function () {
                var _this_1 = this;
                this.loading.institute = true;
                this.rosterService.getInstituteList(null, true).then(function (data) {
                    _this_1.institutes = data.map(function (x) { return ({ value: x.objectId, text: x.caption }); });
                    _this_1.loading.institute = false;
                });
            };
            RosterController.prototype.getEmployees = function () {
                var _this_1 = this;
                this.loading.employee = true;
                this.clientService.getEmployeeList("", this.rosterSettings.showOnlyActiveReferences ? QMC.Common.Constants.SHOW_ONLY_ACTIVE_EMPLOYEES_PREDEFINED_SEARCH_ID : QMC.Common.Constants.SHOW_ALL_EMPLOYEES_PREDEFINED_SEARCH_ID).then(function (data) {
                    var _a;
                    _this_1.employeesList = data;
                    _this_1.employees = data.map(function (x) { return ({ value: x.id, text: _this_1.$qui.createPersonDisplay(x.name, x.forename, x.shortCaption, x.employeeNr), group: x.institute, instituteId: x.instituteId }); });
                    _this_1.employees.sort(function (a, b) { return (a.text.toLocaleLowerCase() > b.text.toLocaleLowerCase()) ? 1 : ((b.text.toLocaleLowerCase() > a.text.toLocaleLowerCase()) ? -1 : 0); });
                    _this_1.employees.sort(function (a, b) { return (a.group.toLocaleLowerCase() > b.group.toLocaleLowerCase()) ? 1 : ((b.group.toLocaleLowerCase() > a.group.toLocaleLowerCase()) ? -1 : 0); });
                    _this_1.loading.employee = false;
                    _this_1.selectedNewReference = $('#session').data().personId;
                    if (!_this_1.employees.some(function (x) { return x.value === _this_1.selectedNewReference; }))
                        _this_1.selectedNewReference = (_a = _this_1.employees[0]) === null || _a === void 0 ? void 0 : _a.value;
                });
            };
            RosterController.prototype.getWvList = function () {
                var _this_1 = this;
                this.loading.wv = true;
                this.rosterService.getRosterWv().then(function (data) {
                    var _a;
                    _this_1.serviceAdditionals = data.additionalWvList.map(function (x) { return ({ value: x.objectId, text: x.name }); });
                    _this_1.predefinedViews = data.predefinedSearchesWvList.map(function (x) { return ({ value: x.objectId, text: x.name }); });
                    _this_1.selectedPredefinedView = (_a = _this_1.rosterSettings.predefinedView) !== null && _a !== void 0 ? _a : _this_1.predefinedViews[0].value;
                    _this_1.getReferenceTypes();
                    _this_1.loading.wv = false;
                });
            };
            RosterController.prototype.getReferenceTypes = function () {
                var _this_1 = this;
                this.loading.referenceTypes = true;
                this.referenceTypes = [
                    { value: 120000, text: this.lng.translate(20000235, "Mitarbeiter") },
                    { value: 130000, text: this.lng.translate(20000236, "Einrichtung") },
                    { value: 190000, text: this.lng.translate(20000237, "Personenliste") },
                ];
                this.selectedReferenceType = this.rosterSettings.referenceType;
                this.selectedReferenceTypeName = this.referenceTypes.filter(function (x) { return x.value === _this_1.selectedReferenceType; })[0].text;
                this.loading.referenceTypes = false;
            };
            RosterController.prototype.getReferences = function (referenceType, reloadCalendar) {
                var _this_1 = this;
                if (referenceType === void 0) { referenceType = this.selectedReferenceType; }
                if (reloadCalendar === void 0) { reloadCalendar = true; }
                this.loading.references = true;
                var referencesMapped = null;
                this.references = [];
                if (referenceType === 120000) {
                    this.clientService.getEmployeeList("", this.rosterSettings.showOnlyActiveReferences ? QMC.Common.Constants.SHOW_ONLY_ACTIVE_EMPLOYEES_PREDEFINED_SEARCH_ID : QMC.Common.Constants.SHOW_ALL_EMPLOYEES_PREDEFINED_SEARCH_ID).then(function (data) {
                        var _a;
                        if (_this_1.selectedReferences.length === 0) {
                            _this_1.selectedReferences.push((data.filter(function (item) { return item.id === $('#session').data().personId; }).length > 0 ? $('#session').data().personId : data[0].id));
                        }
                        referencesMapped = data.map(function (x) { return ({ value: x.id, text: _this_1.$qui.createPersonDisplay(x.name, x.forename, x.shortCaption, x.employeeNr), group: x.institute }); });
                        referencesMapped.sort(function (a, b) { return (a.text.toLocaleLowerCase() > b.text.toLocaleLowerCase()) ? 1 : ((b.text.toLocaleLowerCase() > a.text.toLocaleLowerCase()) ? -1 : 0); });
                        referencesMapped.sort(function (a, b) { return (a.group.toLocaleLowerCase() > b.group.toLocaleLowerCase()) ? 1 : ((b.group.toLocaleLowerCase() > a.group.toLocaleLowerCase()) ? -1 : 0); });
                        _this_1.references = referencesMapped;
                        _this_1.selectedReferenceName = (_a = referencesMapped.filter(function (x) { return x.value === _this_1.selectedReferences[0]; })[0]) === null || _a === void 0 ? void 0 : _a.text;
                        _this_1.getRosterData(reloadCalendar);
                        _this_1.loading.references = false;
                    });
                }
                else {
                    this.rosterService.getReferences(referenceType).then(function (data) {
                        referencesMapped = data.map(function (x) { return ({ value: x.id, text: x.name }); });
                        _this_1.selectedReference = referencesMapped[0].value;
                        _this_1.references = referencesMapped;
                        _this_1.selectedReferenceName = referencesMapped.filter(function (x) { return x.value === _this_1.selectedReference; })[0].text;
                        _this_1.getRosterData(true);
                        _this_1.loading.references = false;
                    });
                }
                ;
            };
            RosterController.prototype.getRosterData = function (forceReload) {
                var _this_1 = this;
                if (!this.calendarCreated &&
                    this.rosterSettings.dataFrom.getDate() != moment(this.rosterSettings.viewDate).toDate().getDate() ||
                    moment(this.rosterSettings.dataFrom).toDate().valueOf() === moment(this.rosterSettings.dataTo).toDate().valueOf()) {
                    this.resetCalendar();
                    this.calendarCreated = true;
                    //force the load of the data after the calender is created
                    setTimeout(function () {
                        _this_1.getRosterData(false);
                    }, 250);
                }
                else {
                    var referencesIds = [];
                    if (this.selectedReferenceType === 120000) {
                        referencesIds = this.selectedReferences;
                    }
                    else {
                        referencesIds = [this.selectedReference];
                    }
                    var dateFrom = this.rosterSettings.dataFrom;
                    var dateTo = this.rosterSettings.dataTo;
                    this.$state.go('Roster', {
                        startDay: moment(this.rosterSettings.dataFrom).format('YYYY-MM-DD')
                    });
                    if (referencesIds.length) {
                        var requestId_1 = this.$qui.generateGuid();
                        var referenceType = this.selectedReferenceType;
                        var references = this.selectedReferenceType === 120000 ? this.selectedReferences : [this.selectedReference];
                        var request = {
                            references: references,
                            referenceType: referenceType,
                            dateFrom: dateFrom,
                            dateTo: dateTo,
                            selectedPredefinedView: this.selectedPredefinedView,
                            includeSub: this.rosterSettings.includeSub
                        };
                        if (JSON.stringify(request) === JSON.stringify(this.lastRequest) && !forceReload)
                            return;
                        this.lastRequestId = requestId_1;
                        this.lastRequest = request;
                        this.rosterSettings.references = this.selectedReferences;
                        this.rosterSettings.predefinedView = this.selectedPredefinedView;
                        this.loading.calendar = true;
                        this.rosterEvents = [];
                        this.rosterData = [];
                        this.rosterResources = [];
                        this.rosterService.getRosterData(referencesIds, referenceType, dateFrom, dateTo, this.selectedPredefinedView, this.rosterSettings.includeSub, this.rosterSettings.showWorkingEventsInfo).then(function (rosterResultData) {
                            if (_this_1.lastRequestId !== requestId_1)
                                return;
                            _this_1.locks = [];
                            rosterResultData.forEach(function (reference) {
                                if (_this_1.rosterData.length === 0 || _this_1.selectedReferenceType !== 120000 || forceReload) {
                                    _this_1.rosterData = reference.data;
                                }
                                else {
                                    _this_1.rosterData.push(reference.data[0]);
                                }
                                for (var _i = 0, _a = _this_1.rosterData; _i < _a.length; _i++) {
                                    var element = _a[_i];
                                    var item = element;
                                    for (var _b = 0, _c = item.services; _b < _c.length; _b++) {
                                        var element_1 = _c[_b];
                                        var service = element_1;
                                        var serviceTypeCaption = '';
                                        var addEvent = true;
                                        if (service.serviceTypeId === QMC.Common.Constants.GUID_EMPTY || service.serviceTypeId === null) {
                                            addEvent = !_this_1.isMobile || _this_1.selectedPredefinedView === '07eb5dfd-7c50-4d43-98ba-491f9d6839b2'; //07eb5dfd-7c50-4d43-98ba-491f9d6839b2 -> summary View
                                            serviceTypeCaption = (_this_1.isMobile && (_this_1.selectedReferenceType === 130000 || _this_1.selectedReferenceType === 190000)) /*Organisation, Person Lists*/ ? item.caption + ': ' + service.caption : service.caption;
                                        }
                                        else {
                                            serviceTypeCaption = service.caption + (" (" + service.captionSub + ")");
                                        }
                                        _this_1.rosterResources.push({
                                            id: service.id,
                                            referenceId: item.id,
                                            referenceInstituteId: item.instituteId,
                                            caption: item.caption,
                                            serviceType: serviceTypeCaption,
                                            serviceTypeId: service.serviceTypeId,
                                            currentValue: service.currentValue,
                                            plannedValue: service.plannedValue,
                                            targetValue: service.targetValue,
                                            totalValue: service.totalValue,
                                            restHolidaysValue: service.restHolidaysValue
                                        });
                                        for (var _e = 0, _f = service.items; _e < _f.length; _e++) {
                                            var element_2 = _f[_e];
                                            var serviceItem = element_2;
                                            //07eb5dfd-7c50-4d43-98ba-491f9d6839b2 -> summary View
                                            if (addEvent) {
                                                _this_1.rosterEvents.push({
                                                    id: serviceItem.id,
                                                    objectId: serviceItem.objectId,
                                                    referenceId: item.id,
                                                    resourceId: service.id,
                                                    serviceTypeId: serviceItem.serviceTypeId,
                                                    serviceSubTypeId: serviceItem.serviceSubTypeId,
                                                    title: _this_1.isMobile ?
                                                        serviceItem.captionShort + ' (' + serviceTypeCaption + ') ' + '-' + ' (' + item.caption + ')' :
                                                        serviceItem.captionShort,
                                                    start: serviceItem.dateFrom,
                                                    end: serviceItem.dateTo,
                                                    color: serviceItem.color,
                                                    captionEventType: serviceItem.captionEventType,
                                                    editable: false,
                                                    fullTitle: serviceItem.caption,
                                                    textColor: _this_1.getTextColor(serviceItem.color)
                                                });
                                            }
                                        }
                                        for (var _g = 0, _h = item.locks; _g < _h.length; _g++) {
                                            var element_3 = _h[_g];
                                            _this_1.locks.push({ id: item.id, locks: item.locks });
                                            for (var _j = 0, _k = item.locks; _j < _k.length; _j++) {
                                                var lock = _k[_j];
                                                _this_1.rosterEvents.push({
                                                    title: '',
                                                    fullTitle: lock.lockDescription,
                                                    start: lock.dateFrom,
                                                    end: lock.dateTo,
                                                    rendering: 'background',
                                                    resourceId: service.id,
                                                    editable: false,
                                                    noPopover: false
                                                });
                                            }
                                        }
                                    }
                                }
                            });
                            var viewDate = _this_1.rosterSettings.viewDate;
                            if (!_this_1.calendarCreated) {
                                _this_1.resetCalendar();
                                _this_1.calendarCreated = true;
                            }
                            else {
                                $('#rosterCalendar').fullCalendar('option', 'resources', _this_1.rosterResources);
                                $('#rosterCalendar').fullCalendar('refetchResources');
                                $('#rosterCalendar').fullCalendar('removeEvents');
                                $('#rosterCalendar').fullCalendar('addEventSource', _this_1.rosterEvents);
                                // change also for mobile ressource view
                                if (_this_1.resourceViewMobileCreated) {
                                    $('#rosterCalendarRessources').fullCalendar('option', 'resources', _this_1.rosterResources);
                                    $('#rosterCalendarRessources').fullCalendar('refetchResources');
                                    $('#rosterCalendarRessources').fullCalendar('removeEvents');
                                    $('#rosterCalendarRessources').fullCalendar('addEventSource', _this_1.rosterEvents);
                                }
                            }
                            $('#rosterCalendar').fullCalendar('gotoDate', viewDate);
                            if (_this_1.resourceViewMobileCreated) {
                                $('#rosterCalendarRessources').fullCalendar('gotoDate', viewDate);
                            }
                            _this_1.loading.calendar = false;
                        });
                    }
                }
            };
            // Posts an Is or Planned Time
            RosterController.prototype.postPlanningOrIsTime = function (form) {
                if (form === void 0) { form = this.serviceForm; }
                this.scrollPosition = $('tbody .fc-time-area .fc-scroller').scrollTop();
                this.loading.calendar = true;
                this.lastRequest = undefined;
                // When form.parentId is given, it will be an Is-Time. Else a planned time.
                if (!form.parentId || form.parentId === QMC.Common.Constants.GUID_EMPTY) {
                    this.postPlannedTime(form);
                }
                else if (!form.objectId || form.objectId === QMC.Common.Constants.GUID_EMPTY) {
                    this.postIsTime(form);
                }
            };
            // Posts a planned time
            RosterController.prototype.postPlannedTime = function (form) {
                var _this_1 = this;
                if (!form.referenceIds || !form.referenceIds.length)
                    form.referenceIds = [form.referenceId];
                this.rosterService.postServicePlanning(form).then(function () {
                    _this_1.$qui.notify(_this_1.$qui.successNote);
                    _this_1.getRosterData(true);
                    _this_1.lastValidation = undefined;
                    _this_1.validation.errors = [];
                    _this_1.validation.warnings = [];
                });
            };
            // Posts an Is-Time
            RosterController.prototype.postIsTime = function (form) {
                var _this_1 = this;
                this.rosterService.postServiceDocu(form.parentId, form).then(function () {
                    _this_1.$qui.notify(_this_1.$qui.successNote);
                    _this_1.getRosterData(true);
                    _this_1.lastValidation = undefined;
                    _this_1.validation.errors = [];
                    _this_1.validation.warnings = [];
                });
            };
            RosterController.prototype.putService = function (form, ignoreWarnings) {
                var _this_1 = this;
                if (form === void 0) { form = this.serviceForm; }
                if (ignoreWarnings === void 0) { ignoreWarnings = false; }
                this.validation.errors = [];
                this.validation.warnings = [];
                var listToCheck = [];
                this.prepareForValidation(form, listToCheck, 1);
                this.lastValidation = JSON.stringify(listToCheck);
                this.validation.isLoading = true;
                form.dateFrom = this.$qui.addTimeToDate(form.dateFrom, form.timeFrom);
                form.dateTo = this.$qui.addTimeToDate(form.dateTo, form.timeTo);
                form.referenceId = form.referenceIds[0];
                this.rosterService.checkForConflictErrors(listToCheck).then(function (conflictsResult) {
                    if (conflictsResult.errors.length > 0 || (conflictsResult.warnings.length > 0 && !ignoreWarnings)) {
                        _this_1.validation.errors = conflictsResult.errors;
                        _this_1.validation.warnings = conflictsResult.warnings;
                        _this_1.showValidationBox = true;
                    }
                    else {
                        _this_1.scrollPosition = $('tbody .fc-time-area .fc-scroller').scrollTop();
                        _this_1.loading.calendar = true;
                        _this_1.lastRequest = undefined;
                        _this_1.rosterService.putService(form.objectId, form).then(function () {
                            _this_1.$qui.notify(_this_1.$qui.successNote);
                        }).finally(function () {
                            _this_1.getRosterData(true);
                            _this_1.lastValidation = undefined;
                            _this_1.validation.errors = [];
                            _this_1.validation.warnings = [];
                        });
                        $('#new-service-modal').modal('hide');
                    }
                }).finally(function () {
                    _this_1.validation.isLoading = false;
                });
                ;
            };
            RosterController.prototype.deleteService = function (form) {
                var _this_1 = this;
                if (form === void 0) { form = this.serviceForm; }
                this.validation.errors = [];
                //before saving check for conflicts
                var listToCheck = [];
                this.prepareForValidation(form, listToCheck, 2);
                this.validation.isLoading = true;
                this.rosterService.checkForConflictErrors(listToCheck).then(function (conflictsResult) {
                    if (conflictsResult.errors.length > 0) {
                        _this_1.validation.errors = conflictsResult.errors;
                        _this_1.validation.isLoading = false;
                        _this_1.showValidationBox = true;
                    }
                    else {
                        _this_1.scrollPosition = $('tbody .fc-time-area .fc-scroller').scrollTop();
                        _this_1.loading.calendar = true;
                        _this_1.lastRequest = undefined;
                        _this_1.rosterService.deleteService(form.objectId).then(function () {
                            _this_1.$qui.notify(_this_1.$qui.deleteNote);
                            _this_1.getRosterData(true);
                        });
                        _this_1.validation.isLoading = false;
                        $('#new-service-modal').modal('hide');
                    }
                });
            };
            RosterController.prototype.getService = function (id, event) {
                var _this_1 = this;
                if (event === void 0) { event = null; }
                //event - use this for when dragging and dropping an event
                this.loading.detail = true;
                if (event === null || event === void 0 ? void 0 : event.start) { // open detail modal right away when detail is modified
                    $('#new-service-modal').modal('show');
                }
                this.rosterService.getService(id).then(function (dataService) {
                    _this_1.serviceForm = dataService;
                    _this_1.serviceForm.dateFrom = _this_1.$qui.createDateFromString(dataService.dateFrom);
                    _this_1.serviceForm.dateTo = _this_1.$qui.createDateFromString(dataService.dateTo);
                    _this_1.serviceForm.timeFrom = _this_1.$qui.createDateFromString(dataService.dateFrom);
                    _this_1.serviceForm.timeTo = _this_1.$qui.createDateFromString(dataService.dateTo);
                    _this_1.serviceForm.referenceIds = [dataService.referenceId];
                    _this_1.isLocked = _this_1.isDateLockedForType(_this_1.serviceForm.referenceIds, !_this_1.serviceForm.parentId ? Roster.Constants.SUBTYPE_PLANNED : Roster.Constants.SUBTYPE_DOCUMENTED, _this_1.serviceForm.dateFrom, _this_1.serviceForm.dateTo);
                    _this_1.validation.errors = _this_1.isLocked ? [_this_1.lng.translate(20028012, 'Im ausgewählten Zeitraum existiert für mindestens einen ausgewählten Mitarbeiter eine Anlagesperre.')] : [];
                    _this_1.$qui.scopeApply(_this_1.$scope);
                    _this_1.permissionService.getPermissionsForDataset(id, 411001).then(function (dataPerm) {
                        var _a, _b;
                        _this_1.permission.service = {
                            delete: dataPerm[0].delete,
                            modify: dataPerm[0].modify,
                            new: _this_1.servicePermission.new
                        };
                        if (event === null || event === void 0 ? void 0 : event.start) {
                            var dateTo = event.end;
                            if (!dateTo) {
                                dateTo = event.start;
                                var diff = moment.duration(moment(_this_1.serviceForm.timeTo).diff(moment(_this_1.serviceForm.timeFrom))).asHours();
                                dateTo.add(diff, 'hours');
                            }
                            _this_1.serviceForm.dateFrom = event.start.toDate();
                            _this_1.serviceForm.dateTo = dateTo.toDate();
                            _this_1.serviceForm.timeFrom = moment(event.start).toDate();
                            _this_1.serviceForm.timeTo = dateTo.toDate();
                        }
                        if (event === null || event === void 0 ? void 0 : event.resourceId) {
                            _this_1.serviceForm.referenceIds = [(_b = (_a = _this_1.rosterResources.filter(function (x) { return x.id === event.resourceId; })[0]) === null || _a === void 0 ? void 0 : _a.referenceId) !== null && _b !== void 0 ? _b : dataService.referenceId];
                        }
                        _this_1.loading.detail = false;
                        document.getElementById('serviceModalBody').scrollTop = 0;
                    });
                });
            };
            ///////////////////////////// SETUP //////////////////////////////
            RosterController.prototype.init = function () {
                var _this_1 = this;
                this.$qui.waitForEl('#newModalButton', function () {
                    $('#newModalButton').click(function () {
                        _this_1.initNewForm();
                        setTimeout(function () {
                            document.getElementById('serviceModalBody').scrollTop = 0;
                        }, 250);
                    });
                });
                this.initNewForm();
            };
            RosterController.prototype.initNewForm = function (template, calendarInfo) {
                var _a;
                if (template === void 0) { template = null; }
                if (calendarInfo === void 0) { calendarInfo = null; }
                this.validation.errors = [];
                this.validation.warnings = [];
                this.lastValidation = undefined;
                this.validation.isLoading = false;
                this.showValidationBox = false;
                var reference = calendarInfo !== null ? calendarInfo.referenceRessource : $('#session').data().personId;
                if (this.employees.length === 0) {
                    this.getEmployees();
                }
                var instituteId = calendarInfo !== null ? calendarInfo.referenceInstituteId : null;
                if (this.employeesList.length > 0) {
                    instituteId = this.employeesList.filter(function (x) { return x.id === reference; })[0].instituteId;
                }
                this.serviceForm = {
                    id: null,
                    objectId: null,
                    additionalWvIds: [],
                    break: template !== null ? template.break : 0,
                    caption: template !== null ? template.caption : "",
                    captionShort: template !== null ? template.captionShort : "",
                    color: template !== null ? template.color : "#FF0000",
                    dateFrom: calendarInfo !== null ? calendarInfo.date : new Date(),
                    dateTo: calendarInfo !== null ? calendarInfo.date : new Date(),
                    instituteId: ((_a = this.institutes) === null || _a === void 0 ? void 0 : _a.length) > 0 ? calendarInfo !== null ? calendarInfo.referenceInstituteId : instituteId : null,
                    institute: null,
                    referenceIds: [reference],
                    referenceId: reference,
                    reference: null,
                    templateId: template !== null ? template.objectId : null,
                    timeFrom: template !== null ? this.$qui.createDateFromString(template.timeFrom) : moment().minutes(0).toDate(),
                    timeTo: template !== null ? this.$qui.createDateFromString(template.timeTo) : moment().minutes(0).toDate(),
                    comment: "",
                    conflictProposedAction: 0
                };
                if (calendarInfo !== null && (!template || (template === null || template === void 0 ? void 0 : template.serviceSubTypeId))) {
                    this.serviceForm.timeFrom.setHours(calendarInfo.timeFrom !== null ? calendarInfo.timeFrom.getHours() : this.serviceForm.timeFrom.getHours() - 1);
                    this.serviceForm.timeTo.setHours(calendarInfo.timeFrom !== null ? calendarInfo.timeTo.getHours() + 1 : this.serviceForm.timeTo.getHours());
                }
                this.$qui.scopeApply(this.$scope);
                this.formState = 'new';
            };
            RosterController.prototype.events = function () {
                var _this_1 = this;
                this.$scope.$watch('vm.selectedTemplateContainer', function () {
                    _this_1.setupDndEvents();
                });
                this.$scope.$watch('vm.selectedReferenceType', function (newVal, oldVal) {
                    var _a, _b;
                    if (newVal !== oldVal && newVal !== (null || undefined || QMC.Common.Constants.GUID_EMPTY)) {
                        _this_1.selectedReferenceTypeName = (_b = (_a = _this_1.referenceTypes.filter(function (x) { return x.value === _this_1.selectedReferenceType; })[0]) === null || _a === void 0 ? void 0 : _a.text) !== null && _b !== void 0 ? _b : '';
                        _this_1.selectedReferences = [];
                        _this_1.rosterSettings.referenceType = _this_1.selectedReferenceType;
                        _this_1.getReferences(_this_1.selectedReferenceType);
                    }
                });
                this.$scope.$watch('vm.selectedReference', function (newVal, oldVal) {
                    if (newVal !== oldVal && newVal !== (null || undefined || QMC.Common.Constants.GUID_EMPTY)) {
                        _this_1.permissionService.getPermissionsForGivenUserAndObjectType(_this_1.selectedReference, 411001).then(function (data) {
                            _this_1.permission.service.new = data && _this_1.servicePermission.new;
                        });
                        _this_1.selectedReferences = [_this_1.selectedReference];
                        _this_1.getRosterData(true);
                        _this_1.rosterSettings.references = [_this_1.selectedReference];
                        _this_1.scrollPosition = 0;
                    }
                });
                this.$scope.$watch('vm.selectedReferences', function (newVal, oldVal) {
                    if ((newVal !== oldVal && newVal !== (null || undefined)) && (newVal.length < oldVal.length)) {
                        _this_1.calendarNoReload = true;
                        var _loop_5 = function (i) {
                            var resourceItem = _this_1.rosterResources[i];
                            var roosterReference = _this_1.selectedReferences.filter(function (x) { return x === resourceItem.referenceId; });
                            if (roosterReference === null || roosterReference.length === 0) {
                                $('#rosterCalendar').fullCalendar('removeResource', resourceItem.referenceId);
                                _this_1.rosterResources.splice(i);
                            }
                        };
                        //remove ressources that are not anymore present in the references list
                        for (var i = 0; i < _this_1.rosterResources.length; i++) {
                            _loop_5(i);
                        }
                        $('#rosterCalendar').fullCalendar('option', 'resources', _this_1.rosterResources);
                        $('#rosterCalendar').fullCalendar('refetchResources');
                        $('#rosterCalendar').fullCalendar('removeEvents');
                        $('#rosterCalendar').fullCalendar('addEventSource', _this_1.rosterEvents);
                        // change also for mobile ressource view
                        if (_this_1.resourceViewMobileCreated) {
                            $('#rosterCalendarRessources').fullCalendar('option', 'resources', _this_1.rosterResources);
                            $('#rosterCalendarRessources').fullCalendar('refetchResources');
                            $('#rosterCalendarRessources').fullCalendar('removeEvents');
                            $('#rosterCalendarRessources').fullCalendar('addEventSource', _this_1.rosterEvents);
                        }
                    }
                    else if (newVal !== oldVal && newVal !== (null || undefined)) {
                        _this_1.calendarNoReload = false;
                        //call the server methods for filling the roster data only for the last inserted item
                        _this_1.getRosterData(true);
                    }
                    _this_1.rosterSettings.references = _this_1.selectedReferences;
                    _this_1.scrollPosition = 0;
                });
                this.$scope.$watch('vm.rosterSettings.includeSub', function (newVal, oldVal) {
                    if (newVal !== oldVal && newVal !== (null || undefined || QMC.Common.Constants.GUID_EMPTY)) {
                        _this_1.getRosterData(true);
                        _this_1.rosterSettings.references = [_this_1.selectedReference];
                        _this_1.scrollPosition = 0;
                    }
                });
                this.$scope.$watch('vm.rosterSettings.showOnlyActiveReferences', function (newVal, oldVal) {
                    if (newVal !== oldVal && newVal !== (null || undefined)) {
                        _this_1.getReferences(_this_1.selectedReferenceType, false);
                    }
                });
                this.$scope.$watch('vm.selectedPredefinedView', function (newVal, oldVal) {
                    if (_this_1.selectedReferences.length === 0 && _this_1.selectedReference !== (null || undefined || QMC.Common.Constants.GUID_EMPTY)) {
                        _this_1.selectedReferences = [_this_1.selectedReference];
                    }
                    if (newVal !== oldVal && newVal !== (null || undefined || QMC.Common.Constants.GUID_EMPTY) && (_this_1.selectedReferences.length > 0 || _this_1.selectedReference !== (null || undefined || QMC.Common.Constants.GUID_EMPTY))) {
                        _this_1.getRosterData(true);
                        _this_1.rosterSettings.predefinedView = _this_1.selectedPredefinedView;
                        _this_1.scrollPosition = 0;
                    }
                });
                this.$scope.$watch('vm.rosterSettings', function () {
                    if (!_this_1.debounceCheck) {
                        _this_1.debounceCheck = true;
                        localStorage.setItem(_this_1.localStorageItemName, JSON.stringify(_this_1.rosterSettings));
                        console.log("rosterSettings have been changed...", _this_1.rosterSettings);
                        setTimeout(function () {
                            _this_1.debounceCheck = false;
                        }, 250);
                    }
                }, true);
                this.$scope.$watch('vm.serviceForm.dateFrom', function (newVal, oldVal) {
                    if (newVal === oldVal)
                        return;
                    if (_this_1.serviceForm.dateTo < _this_1.serviceForm.dateFrom)
                        _this_1.serviceForm.dateTo = _this_1.serviceForm.dateFrom;
                    _this_1.isLocked = _this_1.isDateLockedForType(_this_1.serviceForm.referenceIds, !_this_1.serviceForm.parentId ? Roster.Constants.SUBTYPE_PLANNED : Roster.Constants.SUBTYPE_DOCUMENTED, _this_1.serviceForm.dateFrom, _this_1.serviceForm.dateTo);
                    _this_1.validation.errors = _this_1.isLocked ? [_this_1.lng.translate(20028012, 'Im ausgewählten Zeitraum existiert für mindestens einen ausgewählten Mitarbeiter eine Anlagesperre.')] : [];
                    _this_1.preventNegativeTimePeriods();
                });
                this.$scope.$watch('vm.serviceForm.dateTo', function (newVal, oldVal) {
                    if (newVal === oldVal)
                        return;
                    if (_this_1.serviceForm.dateTo < _this_1.serviceForm.dateFrom)
                        _this_1.serviceForm.dateFrom = _this_1.serviceForm.dateTo;
                    _this_1.isLocked = _this_1.isDateLockedForType(_this_1.serviceForm.referenceIds, !_this_1.serviceForm.parentId ? Roster.Constants.SUBTYPE_PLANNED : Roster.Constants.SUBTYPE_DOCUMENTED, _this_1.serviceForm.dateFrom, _this_1.serviceForm.dateTo);
                    _this_1.validation.errors = _this_1.isLocked ? [_this_1.lng.translate(20028012, 'Im ausgewählten Zeitraum existiert für mindestens einen ausgewählten Mitarbeiter eine Anlagesperre.')] : [];
                    _this_1.preventNegativeTimePeriods();
                });
                this.$scope.$watch('vm.serviceForm.timeFrom', function (newVal, oldVal) {
                    if (newVal === oldVal)
                        return;
                    var from = _this_1.$qui.addTimeToDate(_this_1.serviceForm.dateFrom, _this_1.serviceForm.timeFrom);
                    var to = _this_1.$qui.addTimeToDate(_this_1.serviceForm.dateTo, _this_1.serviceForm.timeTo);
                    if (to < from)
                        _this_1.serviceForm.timeTo = _this_1.serviceForm.timeFrom;
                    _this_1.preventNegativeTimePeriods();
                });
                this.$scope.$watch('vm.serviceForm.timeTo', function (newVal, oldVal) {
                    if (newVal === oldVal)
                        return;
                    var from = _this_1.$qui.addTimeToDate(_this_1.serviceForm.dateFrom, _this_1.serviceForm.timeFrom);
                    var to = _this_1.$qui.addTimeToDate(_this_1.serviceForm.dateTo, _this_1.serviceForm.timeTo);
                    if (to < from)
                        _this_1.serviceForm.timeFrom = _this_1.serviceForm.timeTo;
                    _this_1.preventNegativeTimePeriods();
                });
                this.$scope.$watch('vm.serviceForm.referenceIds', function (newVal, oldVal) {
                    if (newVal === oldVal || newVal.length === 0)
                        return;
                    _this_1.isLocked = _this_1.isDateLockedForType(_this_1.serviceForm.referenceIds, !_this_1.serviceForm.parentId ? Roster.Constants.SUBTYPE_PLANNED : Roster.Constants.SUBTYPE_DOCUMENTED, _this_1.serviceForm.dateFrom, _this_1.serviceForm.dateTo);
                });
                this.$scope.$watch('vm.rosterSettings.showWeekends', function (newVal, oldVal) {
                    if (newVal !== oldVal && !_this_1.debounceCheckShowWeekends) {
                        _this_1.debounceCheckShowWeekends = true;
                        setTimeout(function () {
                            _this_1.resetCalendar(true);
                            _this_1.debounceCheckShowWeekends = false;
                        }, 250);
                    }
                });
                this.$scope.$watch('vm.rosterSettings.highlightWeekends', function (newVal, oldVal) {
                    if (newVal !== oldVal && !_this_1.debounceCheckHighlightWeekends) {
                        _this_1.debounceCheckHighlightWeekends = true;
                        setTimeout(function () {
                            _this_1.resetCalendar(true);
                            _this_1.debounceCheckHighlightWeekends = false;
                        }, 250);
                    }
                });
                this.$scope.$watch('vm.rosterSettings.showWorkingEventsInfo', function (newVal, oldVal) {
                    if (newVal !== oldVal && !_this_1.debounceCheckShowWorkingEventsInfo) {
                        _this_1.debounceCheckShowWorkingEventsInfo = true;
                        setTimeout(function () {
                            _this_1.resetCalendar(true);
                            $('#rosterCalendar').fullCalendar('option', 'resources', _this_1.rosterResources);
                            $('#rosterCalendar').fullCalendar('refetchResources');
                            $('#rosterCalendar').fullCalendar('removeEvents');
                            $('#rosterCalendar').fullCalendar('addEventSource', _this_1.rosterEvents);
                            // change also for mobile ressource view
                            if (_this_1.resourceViewMobileCreated) {
                                $('#rosterCalendarRessources').fullCalendar('option', 'resources', _this_1.rosterResources);
                                $('#rosterCalendarRessources').fullCalendar('refetchResources');
                                $('#rosterCalendarRessources').fullCalendar('removeEvents');
                                $('#rosterCalendarRessources').fullCalendar('addEventSource', _this_1.rosterEvents);
                            }
                            _this_1.debounceCheckShowWorkingEventsInfo = false;
                        }, 250);
                    }
                });
            };
            RosterController.prototype.setupDndEvents = function () {
                var vm = this;
                setTimeout(function () {
                    $('.fc-event.dummy').each(function () {
                        $(this).data('event', {
                            stick: true,
                            id: $(this).data('id'),
                            container: $(this).data('container'),
                            template: $(this).data('template')
                        });
                        $(this).draggable({
                            zIndex: 999,
                            revert: true,
                            revertDuration: 0,
                            start: function (event) { return vm.onDrag(event, vm); },
                            stop: function (event) { return vm.onDrag(event, vm); }
                        });
                    });
                }, 150);
            };
            RosterController.prototype.onDrag = function (event, vm) {
                if (event.type === 'dragstart')
                    vm.isDragging = true;
                if (event.type === 'dragstop') {
                    vm.isDragging = false;
                    vm.hideTemplates();
                }
            };
            RosterController.prototype.getCalendarHeight = function () {
                return $(window).height() * 0.6;
            };
            RosterController.prototype.setupCalendar = function (ressourceView) {
                var _this_1 = this;
                if (ressourceView === void 0) { ressourceView = false; }
                // hide type column if there is only one (or less) resource type rows (services)
                //const hideTypeColumn = false;
                var resourceColumns = this.rosterResources.map(function (x) { return x.serviceType; }).filter(function (value, index, self) { return self.indexOf(value) === index; });
                var hideColumn = resourceColumns.length === 1 ? resourceColumns[0] : undefined;
                var scope = this;
                var nameDefaultColumnSize = this.rosterSettings.showWorkingEventsInfo ? '25%' : '35%';
                var typeDefaultColumnSize = this.rosterSettings.showWorkingEventsInfo ? '35%' : '65%';
                var currentValueDefaultColumnSize = this.rosterSettings.showWorkingEventsInfo ? '5%' : '0%';
                var plannedValueDefaultColumnSize = this.rosterSettings.showWorkingEventsInfo ? '5%' : '0%';
                var targetValueDefaultColumnSize = this.rosterSettings.showWorkingEventsInfo ? '10%' : '0%';
                var totalValueDefaultColumnSize = this.rosterSettings.showWorkingEventsInfo ? '10%' : '0%';
                var restHolidaysValueDefaultColumnSize = this.rosterSettings.showWorkingEventsInfo ? '10%' : '0%';
                var resourceAreaDefaultWidth = this.rosterSettings.showWorkingEventsInfo ? '40%' : '20%';
                this.resourceViewMobileCreated = ressourceView;
                var ressColumns = [
                    {
                        group: true,
                        labelText: this.lng.translate(20000072, 'Name'),
                        field: 'caption',
                        width: ressourceView && !this.rosterSettings.showWorkingEventsInfo ? '0%' : nameDefaultColumnSize,
                        render: function () {
                            var args = [];
                            for (var _i = 0; _i < arguments.length; _i++) {
                                args[_i] = arguments[_i];
                            }
                            var parent;
                            var name;
                            if (hideColumn) {
                                parent = args[1];
                                name = args[2];
                            }
                            else {
                                parent = args[0];
                                name = args[1];
                            }
                            parent.css('display', 'flex');
                            parent.css('align-items', 'center');
                            if (!_this_1.wtOverviewPermission.moduleAccess)
                                return;
                            var button = $(document.createElement('i'));
                            button.hover(function () { return button.addClass('text-primary'); }, function () { return button.removeClass('text-primary'); });
                            button.addClass('qm-icon-trafficlight_off');
                            button.attr('style', 'font-size: 2em; cursor: pointer; margin: -8px -5px; ');
                            button.attr('data-toggle', 'tooltip');
                            button.attr('data-placement', 'top');
                            button.attr('tag', '20001042');
                            button.attr('data-original-title', 'Arbeitszeitenübersicht');
                            button.on('click', function () {
                                _this_1.wtoData = undefined;
                                var id = parent.closest('.fc-widget-content').attr('data-reference');
                                $('#wtoModal').modal('show');
                                _this_1.wtoData = {
                                    personId: id,
                                    name: name
                                };
                                _this_1.$qui.scopeApply(_this_1.$scope);
                            });
                            var cell = parent.find('.fc-cell-text');
                            cell.css('display', 'flex');
                            cell.css('alignItems', 'center');
                            cell.prepend(button[0]);
                        }
                    },
                    {
                        labelText: this.lng.translate(20000025, 'Typ'),
                        field: 'serviceType',
                        width: ressourceView && !this.rosterSettings.showWorkingEventsInfo ? '70%' : typeDefaultColumnSize
                    }
                ];
                if (hideColumn) {
                    ressColumns[0].width = '100%';
                    ressColumns[0].group = false;
                    ressColumns.pop();
                }
                if (this.rosterSettings.showWorkingEventsInfo) {
                    ressColumns = ressColumns.concat([
                        {
                            labelText: this.lng.translate(20028032, 'Ist'),
                            field: 'currentValue',
                            width: ressourceView ? '3%' : currentValueDefaultColumnSize
                        },
                        {
                            labelText: this.lng.translate(20028033, 'Soll'),
                            field: 'plannedValue',
                            width: ressourceView ? '3%' : plannedValueDefaultColumnSize
                        },
                        {
                            labelText: this.lng.translate(20028034, 'Vorgabe'),
                            field: 'targetValue',
                            width: ressourceView ? '8%' : targetValueDefaultColumnSize
                        },
                        {
                            labelText: this.lng.translate(20028035, 'Gesamt'),
                            field: 'totalValue',
                            width: ressourceView ? '8%' : totalValueDefaultColumnSize
                        },
                        {
                            labelText: this.lng.translate(20028036, 'Resturlaub'),
                            field: 'restHolidaysValue',
                            width: ressourceView ? '8%' : restHolidaysValueDefaultColumnSize
                        }
                    ]);
                }
                var calenderViews = this.isMobile && !ressourceView ? 'listDay, listWeek, listMonth' : 'timelineDay, timelineWeek, timelineMonth';
                var defaultCalendarView;
                if (this.isMobile && !ressourceView) {
                    defaultCalendarView = this.rosterSettings.defaultSchedulerView.indexOf('list') >= 0 ? this.rosterSettings.defaultSchedulerView : 'listMonth';
                }
                else {
                    defaultCalendarView = this.rosterSettings.defaultSchedulerView.indexOf('time') >= 0 ? this.rosterSettings.defaultSchedulerView : 'timelineMonth';
                }
                $(ressourceView ? '#rosterCalendarRessources' : '#rosterCalendar').fullCalendar({
                    schedulerLicenseKey: QMC.Common.Constants.FULL_CALENDAR_PREMIUM_LICENSE,
                    contentHeight: this.getCalendarHeight,
                    defaultView: defaultCalendarView,
                    defaultDate: this.rosterSettings.dataFrom,
                    timezone: 'local',
                    locale: 'de',
                    firstDay: 1,
                    weekends: this.rosterSettings.showWeekends,
                    nowIndicator: true,
                    monthNames: this.lng.translate(20018519, 'Januar,Februar,März,April,Mai,Juni,Juli,August,September,Oktober,November,Dezember').split(','),
                    monthNamesShort: this.lng.translate(20018520, 'Jan,Feb,Mrz,Apr,Mai,Jun,Jul,Aug,Sep,Okt,Nov,Dez').split(','),
                    dayNames: this.lng.translate(20018521, 'Sonntag,Montag,Dienstag,Mittwoch,Donnerstag,Freitag,Samstag').split(','),
                    dayNamesShort: this.lng.translate(20018522, 'So.,Mo.,Di.,Mi.,Do.,Fr.,Sa.').split(','),
                    weekNumbers: true,
                    weekNumberCalculation: function (date) { return moment(date).isoWeek(); },
                    views: {
                        month: {
                            titleFormat: 'MMMM YYYY',
                        },
                        week: {
                            titleFormat: 'dddd, D MMM YYYY',
                        },
                        day: {
                            titleFormat: 'dddd D.MMM'
                        }
                    },
                    columnFormat: 'ddd D.M',
                    header: {
                        left: ressourceView ? '' : 'prev,next today',
                        center: 'title',
                        right: ressourceView ? '' : calenderViews
                    },
                    timeFormat: 'H:mm',
                    buttonText: ressourceView ? null : {
                        today: this.lng.translate(20000126, 'Heute'),
                        month: this.lng.translate(20000115, 'Monat'),
                        week: this.lng.translate(20000114, 'Woche'),
                        day: this.lng.translate(20000041, 'Tag')
                    },
                    events: this.rosterEvents,
                    resources: this.rosterResources,
                    resourceColumns: ressColumns,
                    resourceAreaWidth: ressourceView ? '100%' : resourceAreaDefaultWidth,
                    slotLabelFormat: [
                        'KW', 'ddd DD', 'H:mm'
                    ],
                    slotWidth: 48,
                    editable: true,
                    eventStartEditable: true,
                    eventDurationEditable: true,
                    eventResourceEditable: true,
                    droppable: scope.permission.service.new,
                    eventResize: function (event) {
                        console.log("Event resize", event);
                    },
                    eventDrop: function (event, delta, revertFunc) {
                        var _a, _b, _c, _e, _f, _g, _h, _j, _k, _l, _m;
                        $('.popover.in').remove();
                        this.eventReference = { id: event.referenceId, name: (_b = (_a = scope.rosterData.filter(function (x) { return x.id === event.referenceId; })[0]) === null || _a === void 0 ? void 0 : _a.caption) !== null && _b !== void 0 ? _b : '' };
                        if (event.serviceTypeId === Roster.Constants.SERVICE) {
                            scope.formState = 'edit';
                            scope.getService(event.objectId, event);
                        }
                        else if (event.serviceTypeId === Roster.Constants.SERVICE_WV_HOLIDAY) {
                            scope.holidayCalls.edit(event.objectId, (_c = event.start) === null || _c === void 0 ? void 0 : _c.toDate(), (_f = ((_e = event.end) !== null && _e !== void 0 ? _e : event.start)) === null || _f === void 0 ? void 0 : _f.toDate());
                        }
                        else if (event.serviceTypeId === Roster.Constants.SERVICE_WV_DISEASE) {
                            scope.sickLeaveCalls.edit(event.objectId, (_g = event.start) === null || _g === void 0 ? void 0 : _g.toDate(), (_j = ((_h = event.end) !== null && _h !== void 0 ? _h : event.start)) === null || _j === void 0 ? void 0 : _j.toDate());
                        }
                        else if (event.serviceTypeId === Roster.Constants.SERVICE_WV_EXEMPTION) {
                            scope.exemptionCalls.edit(event.objectId, (_k = event.start) === null || _k === void 0 ? void 0 : _k.toDate(), (_m = ((_l = event.end) !== null && _l !== void 0 ? _l : event.start)) === null || _m === void 0 ? void 0 : _m.toDate());
                        }
                        revertFunc();
                    },
                    drop: function (date, jsEvent, ui, resourceId) {
                        // resourceId is the subtype id on which was dropped
                        // You can get the dropped on row info by: $(this).data().event.services.filter(x=> x.id === resourceId)[0]
                        // In that result serviceTypeId and serviceTypeSubId are the real roster type ids
                        var _a;
                        var referenceId = null;
                        for (var _i = 0, _b = scope.rosterData; _i < _b.length; _i++) {
                            var data_2 = _b[_i];
                            for (var _c = 0, _e = data_2.services; _c < _e.length; _c++) {
                                var service = _e[_c];
                                if (service.id === resourceId) {
                                    referenceId = data_2.id;
                                }
                            }
                        }
                        var data = $(this).data().event;
                        var reference = scope.rosterData.filter(function (x) { return x.id === referenceId; })[0];
                        scope.eventReference = { id: referenceId, name: (_a = reference === null || reference === void 0 ? void 0 : reference.caption) !== null && _a !== void 0 ? _a : '', instituteId: reference === null || reference === void 0 ? void 0 : reference.instituteId };
                        var droppedRowData = reference.services.filter(function (x) { return x.id === resourceId; })[0];
                        var droppedRowRosterType = { rosterTypeId: droppedRowData.serviceTypeId, rosterSubTypeId: droppedRowData.serviceSubTypeId };
                        scope.handleTemplateDrop(data.template, moment(date._d).toDate(), droppedRowRosterType);
                    },
                    eventReceive: function (event) {
                        //when any event is received, delete it right away, qmc logic will take care in drop/eventdrop
                        $(ressourceView ? '#rosterCalendarRessources' : '#rosterCalendar').fullCalendar('removeEvents', event._id);
                    },
                    eventClick: function (event) {
                        var _a;
                        _this_1.validation.errors = [];
                        _this_1.validation.warnings = [];
                        _this_1.lastValidation = undefined;
                        var reference = _this_1.rosterData.filter(function (x) { return x.id === event.referenceId; })[0];
                        _this_1.eventReference = { id: event.referenceId, name: (_a = reference === null || reference === void 0 ? void 0 : reference.caption) !== null && _a !== void 0 ? _a : '', instituteId: reference === null || reference === void 0 ? void 0 : reference.instituteId };
                        var serviceTypeId = event.serviceTypeId;
                        var serviceSubTypeId = event.serviceSubTypeId;
                        if (serviceTypeId === Roster.Constants.SERVICE) {
                            if (serviceSubTypeId === Roster.Constants.SUBTYPE_DOCUMENTED)
                                _this_1.openExistingService(event.objectId);
                            if (serviceSubTypeId === Roster.Constants.SUBTYPE_PLANNED)
                                _this_1.openExistingPlannedService(event.objectId);
                        }
                        if (serviceTypeId === Roster.Constants.SERVICE_WV_HOLIDAY) {
                            _this_1.holidayCalls.edit(event.objectId);
                        }
                        if (serviceTypeId === Roster.Constants.SERVICE_WV_DISEASE) {
                            _this_1.sickLeaveCalls.edit(event.objectId);
                        }
                        if (serviceTypeId === Roster.Constants.SERVICE_WV_EXEMPTION) {
                            _this_1.exemptionCalls.edit(event.objectId);
                        }
                    },
                    viewRender: function (view) {
                        var dateToCheck = moment(view.start).startOf('day').toDate();
                        //the calendar is rendered many times, just reload completely the data when changing the dates
                        var needToReloadCompletely = moment(_this_1.rosterSettings.dataFrom).format('YYYY-MM-DD') !== moment(dateToCheck).format('YYYY-MM-DD');
                        // remove time header row from month view
                        var row = $('.fc-time-area').find('tr')[2];
                        if (row !== (null || undefined) && view.name === 'timelineMonth')
                            row.setAttribute('style', 'display:none');
                        if (!_this_1.keepData) {
                            var prev = {
                                dataFrom: _this_1.rosterSettings.dataFrom,
                                dataTo: _this_1.rosterSettings.dataTo
                            };
                            var dataFrom = moment(view.start);
                            var dataTo = moment(view.end);
                            //this.rosterSettings.dataFrom.setHours(0, 0, 0, 0);
                            switch (view.name) {
                                case 'timelineDay':
                                    dataTo = moment(view.start);
                                    break;
                                case 'timelineWeek':
                                    dataTo = moment(view.start).endOf('week');
                                    break;
                                case 'timelineMonth':
                                default:
                                    dataTo = moment(view.start).endOf('month');
                                    break;
                            }
                            _this_1.rosterSettings.dataFrom = moment(dataFrom.startOf('day').format('YYYY-MM-DD HH:mm:ss')).toDate(); //make absolutely sure to get the date whithout timezone to match the server
                            _this_1.rosterSettings.dataTo = moment(dataTo.endOf('day').format('YYYY-MM-DD HH:mm:ss')).toDate();
                            _this_1.rosterSettings.viewDate = new Date(_this_1.rosterSettings.dataFrom);
                            _this_1.rosterSettings.defaultSchedulerView = view.name;
                            var fromChanged = prev.dataFrom.getTime() !== _this_1.rosterSettings.dataFrom.getTime();
                            var toChanged = prev.dataTo.getTime() !== _this_1.rosterSettings.dataTo.getTime();
                            if (fromChanged || toChanged)
                                _this_1.getRosterData(false);
                            else if (_this_1.calendarCreated && !ressourceView && !_this_1.calendarNoReload && needToReloadCompletely) {
                                _this_1.getRosterData(true);
                            }
                        }
                        if (_this_1.rosterSettings.highlightWeekends) {
                            if (view.name === 'timelineMonth') {
                                $('.fc-sat.fc-day').addClass('highlight-weekend');
                                $('.fc-sun.fc-day').addClass('highlight-weekend');
                            }
                            if (view.name === 'timelineWeek' || view.name === 'timelineDay') {
                                var days = document.getElementsByClassName('fc-widget-content');
                                [].forEach.call(days, function (day) {
                                    var date = _this_1.$qui.createDateFromString(day.dataset.date);
                                    if (date.getDay() === 6 || date.getDay() === 0)
                                        day.classList.add('highlight-weekend');
                                });
                            }
                        }
                        _this_1.calendarNoReload = false;
                    },
                    resourceRender: function (resource, element) {
                        element.closest('.fc-widget-content').attr('data-reference', resource.referenceId);
                        if (resource.serviceType.includes(resource.caption)) {
                            //if the view is per organisation or person lists make the cell content text bold, better view
                            element[1].querySelector('.fc-cell-text').setAttribute("style", "font-weight: bold");
                        }
                    },
                    eventRender: function (event, element, view) {
                        if (view.name === 'timelineMonth') {
                            element[0].textContent = event.title;
                        }
                        var timeString = moment(event.start).format('HH:mm');
                        if (event.end) {
                            timeString += "-" + moment(event.end).format('HH:mm');
                            if (moment(event.start).format('DD.MM') !== moment(event.end).format('DD.MM'))
                                timeString = moment(event.start).format('DD.MM HH:mm') + ' - ' + moment(event.end).format('DD.MM HH:mm');
                        }
                        var eventTypeCaption = event.captionEventType ? "(" + event.captionEventType + ")" : "";
                        if (!event.noPopover) {
                            element.popover({
                                animation: true,
                                html: true,
                                delay: 300,
                                content: event.title !== '' ? event.fullTitle + " (" + event.title + ") " + eventTypeCaption + ":<br /> " + timeString : event.fullTitle + "<br /> " + timeString,
                                trigger: 'hover',
                                placement: 'bottom',
                                container: 'body'
                            });
                        }
                    },
                    dayClick: function (date, jsEvent, view, resourceObj) {
                        $('.popover.in').remove();
                        var singleClick = moment(date).toISOString();
                        if (_this_1.dblClick === singleClick) {
                            var calendarInfo = {
                                date: singleClick,
                                timeFrom: view.name === "timelineDay" || view.name === "timelineWeek" ? moment(date).minutes(0).toDate() : null,
                                timeTo: view.name === "timelineDay" || view.name === "timelineWeek" ? moment(date).minutes(0).toDate() : null,
                                referenceRessource: resourceObj.referenceId,
                                referenceInstituteId: resourceObj.referenceInstituteId
                            };
                            var isLockedForDate = _this_1.isDateLockedForType(resourceObj.referenceId, Roster.Constants.SUBTYPE_DOCUMENTED, date, date);
                            if (!isLockedForDate) {
                                _this_1.initNewForm(null, calendarInfo);
                                $('#new-service-modal').modal('show');
                            }
                            _this_1.dblClick = null;
                        }
                        else {
                            _this_1.dblClick = moment(date).toISOString();
                            clearInterval(_this_1.clickTimer);
                            _this_1.clickTimer = setInterval(function () {
                                this.dblClick = null;
                                clearInterval(this.clickTimer);
                            }, 500);
                        }
                    }
                });
            };
            RosterController.prototype.preventNegativeTimePeriods = function () {
                var dateFrom = this.$qui.addTimeToDate(this.serviceForm.dateFrom, this.serviceForm.timeFrom);
                var dateTo = this.$qui.addTimeToDate(this.serviceForm.dateTo, this.serviceForm.dateTo);
                if (dateTo < dateFrom) {
                    this.isNegativeTimePeriodLock = true;
                    this.validation.errors = this.isNegativeTimePeriodLock ? [this.lng.translate(20028027, 'Negative Zeiträume sind nicht zulässig.')] : [];
                }
                else {
                    this.isNegativeTimePeriodLock = false;
                }
            };
            RosterController = __decorate([
                QMC.Controller('QMC.Roster', 'RosterController'),
                QMC.Inject('$location', 'RosterService', '$qui', '$scope', '$stateParams', '$state', 'QmcLanguageService', 'QmcPermissionService', 'KlientService', 'UserService', '$compile', '$timeout')
            ], RosterController);
            return RosterController;
        }());
    })(Roster = QMC.Roster || (QMC.Roster = {}));
})(QMC || (QMC = {}));
var QMC;
(function (QMC) {
    var Roster;
    (function (Roster) {
        var SickLeaveFormDirective = /** @class */ (function () {
            function SickLeaveFormDirective(scope, rosterService, $qui, lng, $timeout) {
                var _this = this;
                this.scope = scope;
                this.rosterService = rosterService;
                this.$qui = $qui;
                this.lng = lng;
                this.$timeout = $timeout;
                this.id = 'sickLeave_' + Math.random().toString(36).substring(2, 11);
                this.formState = 'new';
                this.pauseWatchers = false;
                this.formInvalid = true;
                this.calcedValues = { days: 0, hours: 0 };
                this.validation = { errors: [], warnings: [], loading: false };
                this.promptOptions = {
                    title: this.lng.translate(20028038, 'Krankheit'),
                    yesNo: true,
                    icon: 'qm-icon-mail_virus',
                    text: this.lng.translate(20000290, 'Wollen Sie den Eintrag wirklich löschen?')
                };
                this.$postLink = function () {
                    _this.calls = {
                        new: function (form) {
                            var _a;
                            _this.initForm();
                            _this.formState = 'new';
                            _this.lastValidation = undefined;
                            _this.validation.errors = [];
                            _this.validation.warnings = [];
                            if (form) {
                                _this.form = __assign(__assign({}, form), { isManualDays: true, isManualHours: false, isAccountServices: false });
                                //ensure every form has valid ids for it gets referenced by sickNotes
                                var newId = _this.$qui.generateGuid();
                                if (!_this.form.id)
                                    _this.form.id = (_a = _this.form.objectId) !== null && _a !== void 0 ? _a : newId;
                                if (!_this.form.objectId)
                                    _this.form.objectId = _this.form.id;
                            }
                            if (!_this.form.sickNotes)
                                _this.form.sickNotes = [];
                            _this.calls.open();
                        },
                        edit: function (form, start, end) {
                            var _a;
                            _this.formState = 'edit';
                            _this.lastValidation = undefined;
                            _this.validation.errors = [];
                            _this.validation.warnings = [];
                            if (typeof form === 'string') {
                                _this.loadSickLeave(form, start, end);
                            }
                            else {
                                _this.pauseWatchers = true;
                                _this.form = (_a = __assign(__assign({}, form), { isManualDays: true, isManualHours: false, isAccountServices: false })) !== null && _a !== void 0 ? _a : _this.form;
                                if (start)
                                    _this.form.dateFrom = start;
                                if (end)
                                    _this.form.dateTo = end;
                                setTimeout(function () { _this.pauseWatchers = false; }, 50);
                            }
                            _this.calls.open();
                        },
                        delete: function (form) { _this.deleteSickLeave(form !== null && form !== void 0 ? form : _this.form); },
                        open: function () {
                            $('#' + _this.id).modal('show');
                            _this.validate();
                            _this.createInterface();
                            setTimeout(function () { $("#" + _this.id).find("#standardTabButton_" + _this.id).click(); }, 50);
                            _this.$qui.scopeApply(_this.scope);
                        },
                        close: function () { $('#' + _this.id).modal('hide'); }
                    };
                };
                this.$onDestroy = function () {
                    $('#' + _this.id).remove();
                    $('#sickNote_' + _this.id).remove();
                };
                this.uiForm = {
                    form: [
                        {
                            label: {
                                dateFrom: "Datum von",
                                dateTo: "Datum bis",
                            },
                            type: "DateRange",
                            lngTag: {
                                dateFrom: 20000047,
                                dateTo: 20000054
                            },
                            model: {
                                dateFrom: "dateFrom",
                                dateTo: "dateTo"
                            },
                            style: {
                                class: "col-xs-12"
                            },
                            config: {
                                displayDateTo: true,
                                dateToRequired: true,
                                displayTime: true,
                                disableTime: false,
                                disableDate: false
                            }
                        },
                        {
                            label: "Art",
                            type: "Select2",
                            lngTag: 20000138,
                            model: "diseaseKindId",
                            dataSource: "getDiseaseKinds",
                            style: {
                                class: "col-md-6 col-xs-12"
                            },
                            events: {
                                hideExpression: "qmForm.serviceSubTypeId !== '" + Roster.Constants.SERVICE_SUBTYPE_DISEASE_STANDARD + "'"
                            }
                        },
                        {
                            label: "Anzeigefarbe",
                            type: "Color",
                            lngTag: 20020034,
                            model: "color",
                            disabled: true,
                            style: {
                                class: "col-xs-12",
                                icon: "qm-icon-painters_palette"
                            },
                            events: {
                                hideExpression: "qmForm.serviceSubTypeId === '" + Roster.Constants.SERVICE_SUBTYPE_DISEASE_STANDARD + "'"
                            }
                        },
                        {
                            label: "Anzeigefarbe",
                            type: "Color",
                            lngTag: 20020034,
                            model: "color",
                            disabled: true,
                            style: {
                                class: "col-md-6 col-xs-12",
                                icon: "qm-icon-painters_palette"
                            },
                            events: {
                                hideExpression: "qmForm.serviceSubTypeId !== '" + Roster.Constants.SERVICE_SUBTYPE_DISEASE_STANDARD + "'"
                            }
                        },
                        {
                            label: "Bezeichnung",
                            type: "String",
                            lngTag: 20000053,
                            model: "caption",
                            style: {
                                class: "col-md-6 col-xs-12"
                            }
                        },
                        {
                            label: "Kürzel",
                            type: "String",
                            lngTag: 20000221,
                            model: "captionShort",
                            style: {
                                class: "col-md-3 col-xs-6"
                            }
                        },
                        {
                            label: "Erbringungsort",
                            type: "Select2",
                            lngTag: 20028006,
                            model: "instituteId",
                            dataSource: "getInstitutes",
                            style: {
                                class: "col-xs-12"
                            }
                        },
                        {
                            type: 'hr'
                        },
                        {
                            label: "Anzahl Tage",
                            type: "CheckboxInline",
                            lngTag: 20020026,
                            model: "isManualDays",
                            id: "isManualDays",
                            style: {
                                class: "col-md-2 col-sm-3 col-xs-6"
                            }
                        },
                        {
                            model: "amountOfDays",
                            type: "Number",
                            disabled: true,
                            id: "amountOfDaysDis",
                            style: {
                                class: "col-md-2 col-sm-3 col-xs-6",
                            },
                            events: {
                                hideExpression: "qmForm.isManualDays"
                            }
                        },
                        {
                            model: "amountOfDays",
                            type: "Number",
                            disabled: false,
                            id: "amountOfDays",
                            style: {
                                class: "col-md-2 col-sm-3 col-xs-6",
                            },
                            events: {
                                hideExpression: "!qmForm.isManualDays"
                            }
                        },
                        {
                            label: "Anzahl Stunden",
                            type: "CheckboxInline",
                            lngTag: 20020027,
                            model: "isManualHours",
                            id: "isManualHours",
                            style: {
                                class: "col-md-2 col-sm-3 col-xs-6"
                            }
                        },
                        {
                            model: "amountOfHours",
                            type: "Number",
                            disabled: true,
                            id: "amountOfHoursDis",
                            style: {
                                class: "col-md-2 col-sm-3 col-xs-6"
                            },
                            events: {
                                hideExpression: "qmForm.isManualHours"
                            }
                        },
                        {
                            model: "amountOfHours",
                            type: "Number",
                            disabled: false,
                            id: "amountOfHours",
                            style: {
                                class: "col-md-2 col-sm-3 col-xs-6"
                            },
                            events: {
                                hideExpression: "!qmForm.isManualHours"
                            }
                        },
                        {
                            label: "Dienste anrechnen",
                            type: "CheckboxInline",
                            lngTag: 20020024,
                            model: "isAccountServices",
                            id: "isAccountServices",
                            style: {
                                class: "col-md-4 col-xs-12"
                            }
                        },
                        {
                            type: 'hr'
                        },
                        {
                            label: "Bemerkung",
                            type: "Summernote",
                            maxLength: -1,
                            lngTag: 20000049,
                            model: "comment",
                            style: {
                                class: "col-md-12 col-xs-12",
                            },
                        },
                    ]
                };
                this.sickNoteLoading = false;
                this.sickNoteFormState = 'new';
                this.uiSickNoteForm = {
                    form: [
                        {
                            label: {
                                dateFrom: "Datum von",
                                dateTo: "Datum bis",
                            },
                            type: "DateRange",
                            lngTag: {
                                dateFrom: 20000047,
                                dateTo: 20000054
                            },
                            model: {
                                dateFrom: "dateFrom",
                                dateTo: "dateTo"
                            },
                            style: {
                                class: "col-xs-12"
                            },
                            config: {
                                displayDateTo: true,
                                dateToRequired: true,
                                disableDate: false
                            },
                            required: true
                        },
                        {
                            label: "Art der Krankmeldung",
                            type: "Select2",
                            lngTag: 20028044,
                            model: "typeOfSickNoteId",
                            dataSource: "getSickNoteKinds",
                            style: {
                                class: "col-md-6 col-xs-12"
                            }
                        },
                        {
                            label: "Bezeichnung",
                            type: "String",
                            lngTag: 20000053,
                            model: "caption",
                            style: {
                                class: "col-xs-12"
                            },
                            required: true
                        },
                        {
                            label: "Bemerkung",
                            type: "Textarea",
                            lngTag: 20000049,
                            model: "comment",
                            style: {
                                class: "col-xs-12"
                            }
                        },
                        {
                            label: "Dokumente",
                            type: "Documents",
                            lngTag: "21006000",
                            documentFolderStructure: {
                                documentObjectType: "documentObjectType",
                                objectType: "objectType",
                                parentId: "objectId"
                            },
                            style: {
                                class: "col-xs-12",
                            }
                        }
                    ],
                    actions: {
                        post: 'createSickNote',
                        put: 'updateSickNote',
                        delete: 'deleteSickNote'
                    }
                };
                this.init();
                this.events();
            }
            SickLeaveFormDirective.prototype.init = function () {
                var _this = this;
                this.rosterService.getSickLeaveWv().then(function (data) {
                    _this.wvList = data;
                });
                this.rosterService.getInstituteList().then(function (data) {
                    _this.institutes = data;
                });
                this.initForm();
            };
            SickLeaveFormDirective.prototype.events = function () {
                var _this = this;
                this.scope.$watch('vm.form.diseaseKindId', function (newValue, oldValue) {
                    var _a;
                    if (newValue === oldValue || !newValue)
                        return;
                    var intColor = (_a = _this.wvList.diseaseKindWvList.filter(function (x) { return x.objectId === newValue; })[0]) === null || _a === void 0 ? void 0 : _a.value;
                    if (!intColor)
                        return;
                    _this.form.color = '#' + ('000000' + (intColor & 0xFFFFFF).toString(16)).slice(-6);
                });
                this.scope.$watch('vm.form.isManualDays', function (newValue) {
                    if (_this.pauseWatchers || !newValue || !_this.form)
                        return;
                    _this.form.isManualHours = false;
                    _this.form.isAccountServices = false;
                    _this.form.accountingTypeFlag = 0;
                });
                this.scope.$watch('vm.form.isManualHours', function (newValue) {
                    if (_this.pauseWatchers || !newValue || !_this.form)
                        return;
                    _this.form.isManualDays = false;
                    _this.form.isAccountServices = false;
                    _this.form.accountingTypeFlag = 1;
                });
                this.scope.$watch('vm.form.isAccountServices', function (newValue) {
                    if (_this.pauseWatchers || !newValue || !_this.form)
                        return;
                    _this.form.isManualDays = false;
                    _this.form.isManualHours = false;
                    _this.form.accountingTypeFlag = 2;
                });
                this.scope.$watch('vm.form.dateFrom', function (newValue, oldValue) {
                    if (!newValue)
                        return;
                    if (moment(newValue).format("L") === moment(oldValue).format("L"))
                        return;
                    _this.getCalcDayValues();
                });
                this.scope.$watch('vm.form.dateTo', function (newValue, oldValue) {
                    if (!newValue)
                        return;
                    if (moment(newValue).format("L") === moment(oldValue).format("L"))
                        return;
                    _this.getCalcDayValues();
                });
                this.scope.$watch('vm.form', function () {
                    _this.$timeout(function () {
                        _this.formInvalid = $("#" + _this.id).find("#baseDataTab_" + _this.id).find('.ng-invalid').length > 0;
                    });
                    if (!_this.pauseWatchers) {
                        _this.validate();
                    }
                }, true);
            };
            SickLeaveFormDirective.prototype.initForm = function () {
                var _a, _b, _c, _d;
                var newId = this.$qui.generateGuid();
                this.form = {
                    id: newId,
                    objectId: newId,
                    comment: '',
                    dateFrom: new Date(),
                    dateTo: new Date(),
                    color: '#0000FF',
                    amountOfDays: 0,
                    amountOfHours: 0,
                    accountingTypeFlag: 0,
                    caption: '',
                    captionShort: '',
                    diseaseKindId: null,
                    referenceId: (_b = (_a = this.reference) === null || _a === void 0 ? void 0 : _a.id) !== null && _b !== void 0 ? _b : $('#session').data().personId,
                    instituteId: (_d = (_c = this.reference) === null || _c === void 0 ? void 0 : _c.instituteId) !== null && _d !== void 0 ? _d : null,
                    serviceSubTypeId: Roster.Constants.SERVICE_SUBTYPE_DISEASE_STANDARD,
                    isAccountServices: false,
                    isManualDays: true,
                    isManualHours: false
                };
            };
            SickLeaveFormDirective.prototype.getDiseaseKinds = function () {
                var _a, _b, _c;
                return (_c = (_b = (_a = this.wvList) === null || _a === void 0 ? void 0 : _a.diseaseKindWvList) === null || _b === void 0 ? void 0 : _b.map(function (x) { return ({ text: x.name, value: x.objectId }); })) !== null && _c !== void 0 ? _c : [];
            };
            SickLeaveFormDirective.prototype.getSickNoteKinds = function () {
                var _a, _b, _c;
                return (_c = (_b = (_a = this.wvList) === null || _a === void 0 ? void 0 : _a.sickNoteKindWvList) === null || _b === void 0 ? void 0 : _b.map(function (x) { return ({ text: x.name, value: x.objectId }); })) !== null && _c !== void 0 ? _c : [];
            };
            SickLeaveFormDirective.prototype.getInstitutes = function () {
                var _a, _b;
                return (_b = (_a = this.institutes) === null || _a === void 0 ? void 0 : _a.map(function (x) { return ({ text: x.caption, value: x.objectId }); })) !== null && _b !== void 0 ? _b : [];
            };
            SickLeaveFormDirective.prototype.getPermission = function () {
                if (this.form && this.form.serviceSubTypeId === Roster.Constants.SERVICE_SUBTYPE_DISEASE_ACCIDENT)
                    return this.permissions.accident;
                if (this.form && this.form.serviceSubTypeId === Roster.Constants.SERVICE_SUBTYPE_DISEASE_STANDARD)
                    return this.permissions.standard;
                return {};
            };
            SickLeaveFormDirective.prototype.isEditAllowed = function () {
                var _a, _b, _c, _d, _e, _f, _g;
                if (this.formState === 'new')
                    return (_b = (_a = this.getPermission()) === null || _a === void 0 ? void 0 : _a.new) !== null && _b !== void 0 ? _b : false;
                if (this.formState === 'edit')
                    return (_g = (_e = (_d = (_c = this.form) === null || _c === void 0 ? void 0 : _c.permissions) === null || _d === void 0 ? void 0 : _d.modify) !== null && _e !== void 0 ? _e : (_f = this.getPermission()) === null || _f === void 0 ? void 0 : _f.modify) !== null && _g !== void 0 ? _g : false;
                return false;
            };
            SickLeaveFormDirective.prototype.getCalcDayValues = function () {
                var _this = this;
                if (!this.form.isManualDays)
                    return;
                this.rosterService.calculateDayValues(this.form.dateFrom, this.form.dateTo, this.reference.id).then(function (data) {
                    _this.form.amountOfDays = data.calcDays;
                    if (!_this.form.isManualHours)
                        _this.form.amountOfHours = 0;
                });
            };
            SickLeaveFormDirective.prototype.getButtonClass = function () {
                if (this.validation.errors.length > 0)
                    return 'btn-danger';
                if (this.validation.warnings.length > 0)
                    return 'btn-warning';
                return 'btn-primary';
            };
            SickLeaveFormDirective.prototype.loadSickLeave = function (id, start, end) {
                var _this = this;
                if (!id)
                    return;
                this.loading = true;
                this.rosterService.getSickLeave(id).then(function (data) {
                    _this.pauseWatchers = true;
                    if (start)
                        data.dateFrom = start;
                    if (end)
                        data.dateFrom = end;
                    data.dateFrom = _this.$qui.createDateFromString(data.dateFrom);
                    data.dateTo = _this.$qui.createDateFromString(data.dateTo);
                    switch (data.accountingTypeFlag) {
                        case 1:
                            data.isManualHours = true;
                            break;
                        case 2:
                            data.isAccountServices = true;
                            break;
                        default:
                            data.isManualDays = true;
                            break;
                    }
                    _this.form = data;
                    _this.createInterface();
                    setTimeout(function () {
                        _this.pauseWatchers = false;
                        $("#" + _this.id).find("#standardTabButton_" + _this.id).click();
                    }, 50);
                }).finally(function () { return _this.loading = false; });
            };
            SickLeaveFormDirective.prototype.createInterface = function () {
                if (!this.form)
                    return;
                if (!this.form.id)
                    this.form.id = this.$qui.generateGuid();
                if (this.form.objectId)
                    this.form.objectId = this.form.id;
                this.$qui.functionWaiter('createForm', this);
            };
            SickLeaveFormDirective.prototype.addSickLeave = function (form) {
                var _this = this;
                form = form !== null && form !== void 0 ? form : this.form;
                if (!this.getPermission().new)
                    return;
                if (form.isManualDays)
                    form.accountingTypeFlag = 0;
                if (form.isManualHours)
                    form.accountingTypeFlag = 1;
                if (form.isAccountServices)
                    form.accountingTypeFlag = 2;
                this.loading = true;
                this.rosterService.postSickLeave(form).then(function () {
                    _this.calls.close();
                    _this.callbacks().onNew(form);
                }).finally(function () { return _this.loading = false; });
            };
            SickLeaveFormDirective.prototype.updateSickLeave = function (form) {
                var _this = this;
                var _a;
                form = form !== null && form !== void 0 ? form : this.form;
                if (!((_a = this.form.permissions) === null || _a === void 0 ? void 0 : _a.modify))
                    return;
                if (form.isManualDays)
                    form.accountingTypeFlag = 0;
                if (form.isManualHours)
                    form.accountingTypeFlag = 1;
                if (form.isAccountServices)
                    form.accountingTypeFlag = 2;
                this.loading = true;
                this.rosterService.putSickLeave(form.objectId, form).then(function () {
                    _this.calls.close();
                    _this.callbacks().onEdit(form);
                }).finally(function () { return _this.loading = false; });
            };
            SickLeaveFormDirective.prototype.deleteSickLeave = function (form) {
                var _this = this;
                var _a;
                form = form !== null && form !== void 0 ? form : this.form;
                if (!((_a = this.form.permissions) === null || _a === void 0 ? void 0 : _a.delete))
                    return;
                this.promptOptions.title = this.form.serviceSubTypeId === Roster.Constants.SERVICE_SUBTYPE_DISEASE_STANDARD ? this.lng.translate(20028038, 'Krankheit') : this.lng.translate(20028039, 'Arbeitsunfall');
                this.promptOptions.itemText = form.caption + " (" + moment(form.dateFrom).format('DD.MM.yyyy HH:mm') + " - " + moment(form.dateTo).format('DD.MM.yyyy HH:mm') + ")";
                QMC.Common.Utilities.confirm(this.promptOptions, function (data) {
                    if (!data)
                        return;
                    _this.loading = true;
                    _this.rosterService.deleteSickLeave(form.objectId).then(function () {
                        _this.calls.close();
                        _this.callbacks().onDelete(form);
                    }).finally(function () { return _this.loading = false; });
                }, "#prompt_" + this.id);
            };
            SickLeaveFormDirective.prototype.validate = function () {
                var _this = this;
                var _a, _b, _c, _d;
                if (!this.form)
                    return;
                var validationForm = {
                    entryId: this.form.objectId,
                    referenceId: (_b = (_a = this.reference) === null || _a === void 0 ? void 0 : _a.id) !== null && _b !== void 0 ? _b : $('#session').data().personId,
                    reference: (_d = (_c = this.reference) === null || _c === void 0 ? void 0 : _c.name) !== null && _d !== void 0 ? _d : '',
                    dateFrom: this.form.dateFrom,
                    dateTo: this.form.dateTo,
                    serviceTypeId: Roster.Constants.SERVICE_TYPE_DISEASE,
                    serviceSubTypeId: this.form.serviceSubTypeId,
                    randomId: Math.random().toString(36).substring(2, 11)
                };
                if (this.lastValidation) {
                    var last = angular.copy(this.lastValidation);
                    var current = angular.copy(validationForm);
                    delete last.randomId;
                    delete current.randomId;
                    if (JSON.stringify(last) === JSON.stringify(current))
                        return;
                }
                this.lastValidation = validationForm;
                this.validation.loading = true;
                this.rosterService.validateNonService(validationForm).then(function (data) {
                    if (_this.lastValidation.randomId === validationForm.randomId) {
                        _this.validation = {
                            errors: data.errors,
                            warnings: data.warnings,
                            loading: false
                        };
                    }
                }).catch(function () {
                    _this.validation = {
                        errors: [_this.lng.translate(20028043, 'Es konnte nicht validiert werden')],
                        warnings: [],
                        loading: false
                    };
                });
            };
            SickLeaveFormDirective.prototype.newSickNote = function (form) {
                this.sickNoteForm = form;
                this.sickNoteFormState = 'new';
                // ensure every sickNote has valid ids, for they get referenced by the actual documents
                var newId = this.$qui.generateGuid();
                this.sickNoteForm = {
                    caption: '',
                    comment: '',
                    dateFrom: moment(this.form.dateFrom).startOf('day').toDate(),
                    dateTo: moment(this.form.dateTo).endOf('day').toDate(),
                    id: newId,
                    objectId: newId,
                    typeOfSickNoteId: Roster.Constants.SERVICE_SICKNOTETYPE_INITIALDOCUMENT,
                    typeOfSickNoteCaption: '',
                    parentObjectType: this.form.serviceSubTypeId === Roster.Constants.SERVICE_SUBTYPE_DISEASE_STANDARD ? 411004 : 411006
                };
                this.openSickNoteModal();
            };
            SickLeaveFormDirective.prototype.openSickNoteModal = function () {
                this.sickNoteForm.objectType = 411008;
                this.sickNoteForm.documentObjectType = 411009;
                this.$qui.functionWaiter('createSickNoteForm', this);
                $('#sickNote_' + this.id).modal('show');
            };
            SickLeaveFormDirective.prototype.closeSickNoteModal = function () {
                $('#sickNote_' + this.id).modal('hide');
            };
            SickLeaveFormDirective.prototype.openSickNote = function (form) {
                this.sickNoteForm = form;
                this.sickNoteFormState = 'edit';
                this.openSickNoteModal();
            };
            SickLeaveFormDirective.prototype.createSickNote = function (form) {
                var _this = this;
                if (this.formState === 'new') {
                    form.permissions = this.permissions.document;
                    this.form.sickNotes.push(form);
                }
                else {
                    this.sickNoteLoading = true;
                    this.rosterService.postSickNote(this.form.objectId, form).then(function () {
                        _this.closeSickNoteModal();
                        _this.getSickNotes();
                    }).finally(function () { return _this.sickNoteLoading = false; });
                }
            };
            SickLeaveFormDirective.prototype.updateSickNote = function (form) {
                var _this = this;
                if (this.formState === 'new') {
                    this.form.sickNotes = this.form.sickNotes.filter(function (x) { return x.objectId !== form.objectId; });
                    this.form.sickNotes.push(form);
                }
                else {
                    this.sickNoteLoading = true;
                    this.rosterService.putSickNote(this.form.objectId, form.objectId, form).then(function () {
                        _this.closeSickNoteModal();
                        _this.getSickNotes();
                    }).finally(function () { return _this.sickNoteLoading = false; });
                }
            };
            SickLeaveFormDirective.prototype.getSickNotes = function () {
                var _this = this;
                this.sickNoteLoading = true;
                this.rosterService.getSickNoteList(this.form.objectId).then(function (data) {
                    _this.form.sickNotes = data;
                }).finally(function () { return _this.sickNoteLoading = false; });
            };
            SickLeaveFormDirective.prototype.deleteSickNote = function (form) {
                var _this = this;
                var _a;
                if (!((_a = form.permissions) === null || _a === void 0 ? void 0 : _a.delete))
                    return;
                this.promptOptions.itemText = form.caption + " (" + moment(form.dateFrom).format('DD.MM.yyyy') + " - " + moment(form.dateTo).format('DD.MM.yyyy') + ")";
                QMC.Common.Utilities.confirm(this.promptOptions, function (data) {
                    if (!data)
                        return;
                    if (_this.formState === 'new') {
                        _this.form.sickNotes = _this.form.sickNotes.filter(function (x) { return x.objectId !== form.objectId; });
                    }
                    else {
                        _this.sickNoteLoading = true;
                        _this.rosterService.deleteSickNote(_this.form.objectId, form.objectId).then(function () {
                            _this.closeSickNoteModal();
                            _this.getSickNotes();
                        }).finally(function () { return _this.sickNoteLoading = false; });
                    }
                }, "#prompt_" + this.id);
            };
            return SickLeaveFormDirective;
        }());
        angular.module('QMC.Roster').component('qmSickLeaveForm', {
            templateUrl: './Roster/SickLeaveFormDirective',
            controller: ['$scope', 'RosterService', '$qui', 'QmcLanguageService', '$timeout', SickLeaveFormDirective],
            controllerAs: 'vm',
            bindings: {
                form: '=?',
                permissions: '=',
                calls: '=',
                callbacks: '&',
                reference: '=',
            }
        });
    })(Roster = QMC.Roster || (QMC.Roster = {}));
})(QMC || (QMC = {}));
var QMC;
(function (QMC) {
    var Roster;
    (function (Roster) {
        var ExemptionFormDirective = /** @class */ (function () {
            function ExemptionFormDirective(scope, $qui, rosterService, lng, $timeout) {
                var _this = this;
                this.scope = scope;
                this.$qui = $qui;
                this.rosterService = rosterService;
                this.lng = lng;
                this.$timeout = $timeout;
                this.id = '_' + Math.random().toString(36).substr(2, 9);
                this.formState = 'new';
                this.pauseWatchers = false;
                this.validation = { errors: [], warnings: [], loading: false };
                this.promptOptions = {
                    title: this.lng.translate(20028042, 'Freistellung'),
                    yesNo: true,
                    icon: 'qm-icon-mail-virus',
                    text: this.lng.translate(20000290, 'Wollen Sie den Eintrag wirklich löschen?')
                };
                this.$postLink = function () {
                    _this.calls = {
                        new: function (form) {
                            _this.initForm();
                            _this.formState = 'new';
                            if (form) {
                                _this.form = form;
                            }
                            _this.calls.open();
                        },
                        edit: function (form, start, end) {
                            _this.formState = 'edit';
                            if (typeof form === 'string') {
                                _this.loadExemption(form, start, end);
                            }
                            else {
                                _this.pauseWatchers = true;
                                _this.form = form;
                                if (start)
                                    _this.form.dateFrom = start;
                                if (end)
                                    _this.form.dateTo = end;
                                setTimeout(function () { _this.pauseWatchers = false; }, 50);
                            }
                            _this.calls.open();
                        },
                        delete: function (form) { _this.deleteExemption(form !== null && form !== void 0 ? form : _this.form); },
                        open: function () {
                            $('#' + _this.id).modal('show');
                            _this.validate();
                            _this.createInterface();
                            _this.$qui.scopeApply(_this.scope);
                            _this.$qui.waitForEl("#" + _this.id + "_standardTabButton", function () {
                                $("#" + _this.id + "_standardTabButton").click();
                            });
                        },
                        close: function () { $('#' + _this.id).modal('hide'); }
                    };
                };
                this.$onDestroy = function () {
                    $('#' + _this.id).remove();
                };
                this.formSchema = {
                    form: [
                        {
                            label: {
                                dateFrom: "Datum von",
                                dateTo: "Datum bis",
                            },
                            placeholder: {
                                dateFrom: "Datum von",
                                dateTo: "Datum bis"
                            },
                            type: "DateRange",
                            lngTag: {
                                dateFrom: 20000047,
                                dateTo: 20000054
                            },
                            model: {
                                dateFrom: "dateFrom",
                                dateTo: "dateTo"
                            },
                            style: {
                                class: "col-xs-12"
                            },
                            config: {
                                displayDateTo: true,
                                dateToRequired: true,
                                displayTime: true,
                                disableTime: false,
                                disableDate: false
                            }
                        },
                        {
                            label: "Art",
                            type: "Select2",
                            model: "exemptionKindId",
                            lngTag: 20000138,
                            dataSource: "getExemptionKindList",
                            style: {
                                class: "col-md-6 col-xs-12"
                            },
                        },
                        {
                            label: "Anzeigefarbe",
                            type: "Color",
                            lngTag: 20020034,
                            model: "color",
                            style: {
                                class: "col-md-6 col-xs-12",
                                icon: "qm-icon-painters_palette"
                            }
                        },
                        {
                            label: "Bezeichnung",
                            type: "String",
                            model: "caption",
                            lngTag: 20000053,
                            style: {
                                class: "col-md-6 col-xs-12"
                            }
                        },
                        {
                            label: "Kürzel",
                            type: "String",
                            model: "captionShort",
                            lngTag: 20000221,
                            style: {
                                class: "col-md-6 col-xs-12"
                            }
                        },
                        {
                            label: "Erbringungsort",
                            type: "Select2",
                            dataSource: "getInstitutes",
                            model: "instituteId",
                            lngTag: 20028006,
                            style: {
                                class: "col-md-6 col-xs-12"
                            }
                        },
                        {
                            label: "Genehmigungsstatus",
                            type: "Select",
                            dataSource: "getApprovementWvList",
                            model: "approvedId",
                            id: "approvedId",
                            lngTag: 20020007,
                            events: {
                                hideExpression: "!qmForm.permissionApproved"
                            },
                            style: {
                                class: "col-md-6 col-xs-12",
                                icon: "qm-icon-information"
                            }
                        },
                        {
                            label: "Genehmigungsstatus",
                            type: "Select",
                            dataSource: "getApprovementWvList",
                            model: "approvedId",
                            lngTag: 20020007,
                            disabled: true,
                            events: {
                                hideExpression: "qmForm.permissionApproved"
                            },
                            style: {
                                class: "col-md-6 col-xs-12",
                                icon: "qm-icon-information"
                            }
                        },
                        {
                            label: "Bemerkung",
                            type: "Summernote",
                            lngTag: 20000049,
                            model: "comment",
                            style: {
                                class: "col-md-12 col-xs-12",
                            },
                        }
                    ],
                    actions: {
                        put: "updateExemption",
                        post: "addExemption",
                        delete: "deleteExemption"
                    }
                };
                this.init();
                this.events();
            }
            ExemptionFormDirective.prototype.validate = function () {
                var _this = this;
                var _a, _b, _c, _d;
                if (!this.form)
                    return;
                var validationForm = {
                    entryId: this.form.objectId,
                    referenceId: (_b = (_a = this.reference) === null || _a === void 0 ? void 0 : _a.id) !== null && _b !== void 0 ? _b : $('#session').data().personId,
                    reference: (_d = (_c = this.reference) === null || _c === void 0 ? void 0 : _c.name) !== null && _d !== void 0 ? _d : '',
                    dateFrom: this.form.dateFrom,
                    dateTo: this.form.dateTo,
                    serviceTypeId: Roster.Constants.SERVICE_TYPE_EXEMPTION,
                    serviceSubTypeId: Roster.Constants.SERVICE_TYPE_EXEMPTION,
                    randomId: Math.random().toString(36).substring(2, 11)
                };
                if (this.lastValidation) {
                    var last = angular.copy(this.lastValidation);
                    var current = angular.copy(validationForm);
                    delete last.randomId;
                    delete current.randomId;
                    if (JSON.stringify(last) === JSON.stringify(current))
                        return;
                }
                this.lastValidation = validationForm;
                this.validation.loading = true;
                this.rosterService.validateNonService(validationForm).then(function (data) {
                    if (_this.lastValidation.randomId === validationForm.randomId) {
                        _this.validation = {
                            errors: data.errors,
                            warnings: data.warnings,
                            loading: false
                        };
                    }
                }).catch(function () {
                    _this.validation = {
                        errors: [_this.lng.translate(20028043, 'Es konnte nicht validiert werden')],
                        warnings: [],
                        loading: false
                    };
                });
            };
            ExemptionFormDirective.prototype.formatForm = function () {
                if (this.form) {
                    this.form.approved = this.getApprovementWvItem(this.form.approvedId);
                    this.form.permissionApproved = this.permissions.approved.openFile;
                }
            };
            ExemptionFormDirective.prototype.init = function () {
                var _this = this;
                this.rosterService.getExemptionWv().then(function (data) {
                    _this.wvList = data;
                });
                this.rosterService.getInstituteList().then(function (data) {
                    _this.institutes = data;
                });
                this.initForm();
            };
            ExemptionFormDirective.prototype.getInstitutes = function () {
                var _a, _b;
                return (_b = (_a = this.institutes) === null || _a === void 0 ? void 0 : _a.map(function (x) { return ({ text: x.caption, value: x.objectId }); })) !== null && _b !== void 0 ? _b : [];
            };
            ExemptionFormDirective.prototype.events = function () {
                var _this = this;
                this.scope.$watch('vm.form.exemptionKindId', function (newValue, oldValue) {
                    var _a;
                    if (newValue === oldValue || !newValue)
                        return;
                    var intColor = (_a = _this.wvList.exemptionKindWvList.filter(function (x) { return x.objectId === newValue; })[0]) === null || _a === void 0 ? void 0 : _a.value;
                    if (!intColor)
                        return;
                    _this.form.color = '#' + ('000000' + (intColor & 0xFFFFFF).toString(16)).slice(-6);
                });
                this.scope.$watch('vm.form.dateFrom', function (newValue, oldValue) {
                    if (!newValue)
                        return;
                    if (moment(newValue).format("L") === moment(oldValue).format("L"))
                        return;
                });
                this.scope.$watch('vm.form.dateTo', function (newValue, oldValue) {
                    if (!newValue)
                        return;
                    if (moment(newValue).format("L") === moment(oldValue).format("L"))
                        return;
                });
                this.scope.$watch('vm.form', function () {
                    if (!_this.pauseWatchers) {
                        _this.validate();
                    }
                }, true);
            };
            ExemptionFormDirective.prototype.initForm = function () {
                var _a, _b, _c, _d;
                var newId = this.$qui.generateGuid();
                this.form = {
                    id: newId,
                    objectId: newId,
                    referenceId: this.scope.referenceId,
                    caption: this.lng.translate(20028042, 'Freistellung'),
                    color: '#0000FF',
                    dateFrom: new Date(),
                    dateTo: new Date(),
                    comment: '',
                    captionShort: '',
                    exemptionKindId: null,
                    instituteId: (_b = (_a = this.reference) === null || _a === void 0 ? void 0 : _a.instituteId) !== null && _b !== void 0 ? _b : null,
                    permissionApproved: (_d = (_c = this.permissions) === null || _c === void 0 ? void 0 : _c.approved) === null || _d === void 0 ? void 0 : _d.openFile,
                    approvedId: null,
                    approvedById: null
                };
            };
            ExemptionFormDirective.prototype.getApprovementWvList = function () {
                return this.wvList.approvementTypeWvList.map(function (x) { return ({ text: x.name, value: x.objectId }); });
            };
            ExemptionFormDirective.prototype.getApprovementWvItem = function (approvedId) {
                var _a, _b;
                var result = this.wvList.approvementTypeWvList.filter(function (item) { return item.objectId === approvedId; });
                return result ? (_b = (_a = result[0]) === null || _a === void 0 ? void 0 : _a.name) !== null && _b !== void 0 ? _b : '' : '';
            };
            ExemptionFormDirective.prototype.getExemptionKindList = function () {
                var result = this.wvList.exemptionKindWvList.map(function (x) { return ({ text: x.name, value: x.objectId }); });
                result.unshift({ text: '', value: QMC.Common.Constants.GUID_EMPTY });
                return result;
            };
            ExemptionFormDirective.prototype.loadExemption = function (id, start, end) {
                var _this = this;
                if (!id)
                    return;
                this.loading = true;
                this.rosterService.getExemption(id).then(function (data) {
                    _this.pauseWatchers = true;
                    if (start)
                        data.dateFrom = start;
                    if (end)
                        data.dateFrom = end;
                    data.dateFrom = _this.$qui.createDateFromString(data.dateFrom);
                    data.dateTo = _this.$qui.createDateFromString(data.dateTo);
                    _this.form = data;
                    _this.formatForm();
                    _this.createInterface();
                    setTimeout(function () {
                        _this.pauseWatchers = false;
                    }, 50);
                }).finally(function () { return _this.loading = false; });
            };
            ExemptionFormDirective.prototype.createInterface = function () {
                if (!this.form)
                    return;
                this.$qui.functionWaiter('createForm', this);
            };
            ExemptionFormDirective.prototype.addExemption = function (form) {
                var _this = this;
                form = form !== null && form !== void 0 ? form : this.form;
                if (!this.permissions.standard.new)
                    return;
                this.loading = true;
                this.rosterService.postExemption(form).then(function () {
                    _this.calls.close();
                    _this.callbacks.onNew(form);
                }).finally(function () { return _this.loading = false; });
            };
            ExemptionFormDirective.prototype.updateExemption = function (form) {
                var _this = this;
                form = form !== null && form !== void 0 ? form : this.form;
                if (!this.form.permissions.modify)
                    return;
                this.loading = true;
                this.rosterService.putExemption(form.objectId, form).then(function () {
                    _this.calls.close();
                    _this.callbacks.onEdit(form);
                }).finally(function () { return _this.loading = false; });
            };
            ExemptionFormDirective.prototype.deleteExemption = function (form) {
                var _this = this;
                form = form !== null && form !== void 0 ? form : this.form;
                if (!this.form.permissions.delete)
                    return;
                this.promptOptions.title = this.lng.translate(20028042, 'Freistellung');
                this.promptOptions.itemText = form.caption + " (" + moment(form.dateFrom).format('DD.MM.yyyy HH:mm') + " - " + moment(form.dateTo).format('DD.MM.yyyy HH:mm') + ")";
                QMC.Common.Utilities.confirm(this.promptOptions, function (data) {
                    if (!data)
                        return;
                    _this.loading = true;
                    _this.rosterService.deleteExemption(form.objectId).then(function () {
                        _this.calls.close();
                        _this.callbacks.onDelete(form);
                    }).finally(function () { return _this.loading = false; });
                }, "#prompt_" + this.id);
            };
            return ExemptionFormDirective;
        }());
        angular.module('QMC.Roster').component('qmExemptionForm', {
            templateUrl: './Roster/ExemptionForm',
            controller: ['$scope', '$qui', 'RosterService', 'QmcLanguageService', '$timeout', ExemptionFormDirective],
            controllerAs: 'vm',
            bindings: {
                form: '=?',
                permissions: '=',
                calls: '=',
                callbacks: '=',
                reference: '='
            }
        });
    })(Roster = QMC.Roster || (QMC.Roster = {}));
})(QMC || (QMC = {}));
var QMC;
(function (QMC) {
    var Roster;
    (function (Roster) {
        /**
         * Time tracking user interface class
         */
        var UserInterfaceTimeTracking = /** @class */ (function (_super) {
            __extends(UserInterfaceTimeTracking, _super);
            function UserInterfaceTimeTracking() {
                var _this = _super !== null && _super.apply(this, arguments) || this;
                _this.showMonthFilter = true;
                /**
                 * time tracking item list table / only testing purpose right now, NOT final
                 * @memberof UserInterface
                 */
                _this.timeTrackingListTable = {
                    "config": {
                        "defaultSort": "timeStamp",
                        "sortReverse": "true"
                    },
                    "filter": {
                        model: null
                    },
                    "table": {
                        "Stempeldatum": {
                            "label": "timeStamp",
                            "dType": "Date",
                            "lngTag": "0"
                        },
                        "Bezeichnung": {
                            "label": "caption",
                            "dType": "string",
                            "lngTag": "0"
                        },
                        "Aktionen": [{
                                "icon": "qm-icon-eye blue",
                                "click": "",
                                "dType": "Button",
                                "tooltip": "Betrachten",
                                "lngTag": "0"
                            }]
                    }, "card": {
                        "avatar": {
                            "icon": "qm-icon-clock"
                        },
                        "text": {
                            "label": "caption",
                            "dType": "string"
                        },
                        "subtext": [
                            {
                                "label": "timeStamp",
                                "dType": "Date"
                            }
                        ],
                        "buttons": [
                            {
                                "icon": "qm-icon-eye blue",
                                "click": "",
                                "dType": "Button",
                                "tooltip": "Betrachten",
                                "lngTag": "0"
                            }
                        ]
                    },
                    "data": null
                };
                return _this;
            }
            return UserInterfaceTimeTracking;
        }(QMC.Common.UserInterface));
        Roster.UserInterfaceTimeTracking = UserInterfaceTimeTracking;
    })(Roster = QMC.Roster || (QMC.Roster = {}));
})(QMC || (QMC = {}));
var QMC;
(function (QMC) {
    var Roster;
    (function (Roster) {
        var TimeTrackingConstants = /** @class */ (function () {
            function TimeTrackingConstants() {
            }
            TimeTrackingConstants.TIME_TRACKING_STAMP_IN = '829F4DFB-F4E0-4921-8AC1-8C4F83952593';
            TimeTrackingConstants.TIME_TRACKING_STAMP_OUT = '04C5C2E9-1485-4466-BF46-DE4428DD3DA7';
            return TimeTrackingConstants;
        }());
        Roster.TimeTrackingConstants = TimeTrackingConstants;
    })(Roster = QMC.Roster || (QMC.Roster = {}));
})(QMC || (QMC = {}));
var QMC;
(function (QMC) {
    var Roster;
    (function (Roster) {
        var TimeTrackingService = /** @class */ (function (_super) {
            __extends(TimeTrackingService, _super);
            function TimeTrackingService() {
                var _this = _super !== null && _super.apply(this, arguments) || this;
                _this.timeTrackingPath = '/TimeTracking';
                return _this;
            }
            TimeTrackingService.prototype.checkTimeTrackingAvailable = function () {
                return _super.prototype.getItem.call(this, this.timeTrackingPath + '/CheckAvailable').then(function (data) {
                    return data;
                });
            };
            TimeTrackingService.prototype.getLatestTimeTrackingDetailItem = function () {
                return _super.prototype.getItem.call(this, this.timeTrackingPath + '/GetLatest').then(function (data) {
                    return data;
                });
            };
            TimeTrackingService.prototype.postTimeTrackingStart = function (comment) {
                return _super.prototype.post.call(this, this.timeTrackingPath + '/Start', { comment: comment }).then(function (data) {
                    return data;
                });
            };
            TimeTrackingService.prototype.postTimeTrackingStop = function (comment) {
                return _super.prototype.post.call(this, this.timeTrackingPath + '/Stop', { comment: comment }).then(function (data) {
                    return data;
                });
            };
            TimeTrackingService.prototype.getTimeTrackingItemList = function () {
                return _super.prototype.get.call(this, this.timeTrackingPath, { page: -1, pageSize: -1 }).then(function (data) {
                    return data.items;
                });
            };
            TimeTrackingService = __decorate([
                QMC.Service('QMC.Roster', 'TimeTrackingService'),
                QMC.Inject('$http', '$q')
            ], TimeTrackingService);
            return TimeTrackingService;
        }(QMC.Common.BaseService));
        Roster.TimeTrackingService = TimeTrackingService;
    })(Roster = QMC.Roster || (QMC.Roster = {}));
})(QMC || (QMC = {}));

//# sourceMappingURL=../../maps/Roster/qmc.roster.js.map
